var Cr = Object.defineProperty;
var Mr = (e, t, r) => (t in e ? Cr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : (e[t] = r));
var ce = (e, t, r) => (Mr(e, typeof t != "symbol" ? t + "" : t, r), r);
  var St = `<div class="wishlist-empty">
    <p>Your wishlist is empty.</p>
  </div>`;
(function () {
    const t = document.createElement("link").relList;
    if (t && t.supports && t.supports("modulepreload")) return;
    for (const n of document.querySelectorAll('link[rel="modulepreload"]')) i(n);
    new MutationObserver((n) => {
        for (const o of n)
            if (o.type === "childList")
                for (const a of o.addedNodes) a.tagName === "LINK" && a.rel === "modulepreload" && i(a);
    }).observe(document, { childList: !0, subtree: !0 });
    function r(n) {
        const o = {};
        return (
            n.integrity && (o.integrity = n.integrity),
            n.referrerPolicy && (o.referrerPolicy = n.referrerPolicy),
            n.crossOrigin === "use-credentials"
                ? (o.credentials = "include")
                : n.crossOrigin === "anonymous"
                  ? (o.credentials = "omit")
                  : (o.credentials = "same-origin"),
            o
        );
    }
    function i(n) {
        if (n.ep) return;
        n.ep = !0;
        const o = r(n);
        fetch(n.href, o);
    }
})();
function at(e, t, r) {
    return Math.max(e, Math.min(t, r));
}
class kr {
    advance(t) {
        var s;
        if (!this.isRunning) return;
        let r = !1;
        if (this.lerp)
            (this.value =
                ((i = this.value),
                (n = this.to),
                (o = 60 * this.lerp),
                (a = t),
                (function (l, u, d) {
                    return (1 - d) * l + d * u;
                })(i, n, 1 - Math.exp(-o * a)))),
                Math.round(this.value) === this.to && ((this.value = this.to), (r = !0));
        else {
            this.currentTime += t;
            const l = at(0, this.currentTime / this.duration, 1);
            r = l >= 1;
            const u = r ? 1 : this.easing(l);
            this.value = this.from + (this.to - this.from) * u;
        }
        var i, n, o, a;
        (s = this.onUpdate) == null || s.call(this, this.value, r), r && this.stop();
    }
    stop() {
        this.isRunning = !1;
    }
    fromTo(t, r, { lerp: i = 0.1, duration: n = 1, easing: o = (l) => l, onStart: a, onUpdate: s }) {
        (this.from = this.value = t),
            (this.to = r),
            (this.lerp = i),
            (this.duration = n),
            (this.easing = o),
            (this.currentTime = 0),
            (this.isRunning = !0),
            a == null || a(),
            (this.onUpdate = s);
    }
}
class Dr {
    constructor({ wrapper: t, content: r, autoResize: i = !0, debounce: n = 250 } = {}) {
        ce(this, "resize", () => {
            this.onWrapperResize(), this.onContentResize();
        });
        ce(this, "onWrapperResize", () => {
            this.wrapper === window
                ? ((this.width = window.innerWidth), (this.height = window.innerHeight))
                : ((this.width = this.wrapper.clientWidth), (this.height = this.wrapper.clientHeight));
        });
        ce(this, "onContentResize", () => {
            this.wrapper === window
                ? ((this.scrollHeight = this.content.scrollHeight), (this.scrollWidth = this.content.scrollWidth))
                : ((this.scrollHeight = this.wrapper.scrollHeight), (this.scrollWidth = this.wrapper.scrollWidth));
        });
        (this.wrapper = t),
            (this.content = r),
            i &&
                ((this.debouncedResize = (function (o, a) {
                    let s;
                    return function () {
                        let l = arguments,
                            u = this;
                        clearTimeout(s),
                            (s = setTimeout(function () {
                                o.apply(u, l);
                            }, a));
                    };
                })(this.resize, n)),
                this.wrapper === window
                    ? window.addEventListener("resize", this.debouncedResize, !1)
                    : ((this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize)),
                      this.wrapperResizeObserver.observe(this.wrapper)),
                (this.contentResizeObserver = new ResizeObserver(this.debouncedResize)),
                this.contentResizeObserver.observe(this.content)),
            this.resize();
    }
    destroy() {
        var t, r;
        (t = this.wrapperResizeObserver) == null || t.disconnect(),
            (r = this.contentResizeObserver) == null || r.disconnect(),
            window.removeEventListener("resize", this.debouncedResize, !1);
    }
    get limit() {
        return { x: this.scrollWidth - this.width, y: this.scrollHeight - this.height };
    }
}
class or {
    constructor() {
        this.events = {};
    }
    emit(t, ...r) {
        let i = this.events[t] || [];
        for (let n = 0, o = i.length; n < o; n++) i[n](...r);
    }
    on(t, r) {
        var i;
        return (
            ((i = this.events[t]) != null && i.push(r)) || (this.events[t] = [r]),
            () => {
                var n;
                this.events[t] = (n = this.events[t]) == null ? void 0 : n.filter((o) => r !== o);
            }
        );
    }
    off(t, r) {
        var i;
        this.events[t] = (i = this.events[t]) == null ? void 0 : i.filter((n) => r !== n);
    }
    destroy() {
        this.events = {};
    }
}
class Rr {
    constructor(t, { wheelMultiplier: r = 1, touchMultiplier: i = 2, normalizeWheel: n = !1 }) {
        ce(this, "onTouchStart", (t) => {
            const { clientX: r, clientY: i } = t.targetTouches ? t.targetTouches[0] : t;
            (this.touchStart.x = r),
                (this.touchStart.y = i),
                (this.lastDelta = { x: 0, y: 0 }),
                this.emitter.emit("scroll", { deltaX: 0, deltaY: 0, event: t });
        });
        ce(this, "onTouchMove", (t) => {
            const { clientX: r, clientY: i } = t.targetTouches ? t.targetTouches[0] : t,
                n = -(r - this.touchStart.x) * this.touchMultiplier,
                o = -(i - this.touchStart.y) * this.touchMultiplier;
            (this.touchStart.x = r),
                (this.touchStart.y = i),
                (this.lastDelta = { x: n, y: o }),
                this.emitter.emit("scroll", { deltaX: n, deltaY: o, event: t });
        });
        ce(this, "onTouchEnd", (t) => {
            this.emitter.emit("scroll", { deltaX: this.lastDelta.x, deltaY: this.lastDelta.y, event: t });
        });
        ce(this, "onWheel", (t) => {
            let { deltaX: r, deltaY: i } = t;
            this.normalizeWheel && ((r = at(-100, r, 100)), (i = at(-100, i, 100))),
                (r *= this.wheelMultiplier),
                (i *= this.wheelMultiplier),
                this.emitter.emit("scroll", { deltaX: r, deltaY: i, event: t });
        });
        (this.element = t),
            (this.wheelMultiplier = r),
            (this.touchMultiplier = i),
            (this.normalizeWheel = n),
            (this.touchStart = { x: null, y: null }),
            (this.emitter = new or()),
            this.element.addEventListener("wheel", this.onWheel, { passive: !1 }),
            this.element.addEventListener("touchstart", this.onTouchStart, { passive: !1 }),
            this.element.addEventListener("touchmove", this.onTouchMove, { passive: !1 }),
            this.element.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
    }
    on(t, r) {
        return this.emitter.on(t, r);
    }
    destroy() {
        this.emitter.destroy(),
            this.element.removeEventListener("wheel", this.onWheel, { passive: !1 }),
            this.element.removeEventListener("touchstart", this.onTouchStart, { passive: !1 }),
            this.element.removeEventListener("touchmove", this.onTouchMove, { passive: !1 }),
            this.element.removeEventListener("touchend", this.onTouchEnd, { passive: !1 });
    }
}
class Pr {
    constructor({
        wrapper: t = window,
        content: r = document.documentElement,
        wheelEventsTarget: i = t,
        eventsTarget: n = i,
        smoothWheel: o = !0,
        syncTouch: a = !1,
        syncTouchLerp: s = 0.075,
        touchInertiaMultiplier: l = 35,
        duration: u,
        easing: d = (c) => Math.min(1, 1.001 - Math.pow(2, -10 * c)),
        lerp: p = !u && 0.1,
        infinite: y = !1,
        orientation: m = "vertical",
        gestureOrientation: b = "vertical",
        touchMultiplier: S = 1,
        wheelMultiplier: w = 1,
        normalizeWheel: h = !1,
        autoResize: E = !0,
        __experimental__naiveDimensions: _ = !1,
    } = {}) {
        (this.__isSmooth = !1),
            (this.__isScrolling = !1),
            (this.__isStopped = !1),
            (this.__isLocked = !1),
            (this.onVirtualScroll = ({ deltaX: c, deltaY: g, event: v }) => {
                if (v.ctrlKey) return;
                const T = v.type.includes("touch"),
                    R = v.type.includes("wheel");
                if (this.options.syncTouch && T && v.type === "touchstart") return void this.reset();
                const k = c === 0 && g === 0,
                    C =
                        (this.options.gestureOrientation === "vertical" && g === 0) ||
                        (this.options.gestureOrientation === "horizontal" && c === 0);
                if (k || C) return;
                let M = v.composedPath();
                if (
                    ((M = M.slice(0, M.indexOf(this.rootElement))),
                    M.find((P) => {
                        var $, I, H, W, F;
                        return (
                            (($ = P.hasAttribute) === null || $ === void 0
                                ? void 0
                                : $.call(P, "data-lenis-prevent")) ||
                            (T &&
                                ((I = P.hasAttribute) === null || I === void 0
                                    ? void 0
                                    : I.call(P, "data-lenis-prevent-touch"))) ||
                            (R &&
                                ((H = P.hasAttribute) === null || H === void 0
                                    ? void 0
                                    : H.call(P, "data-lenis-prevent-wheel"))) ||
                            (((W = P.classList) === null || W === void 0 ? void 0 : W.contains("lenis")) &&
                                !(!((F = P.classList) === null || F === void 0) && F.contains("lenis-stopped")))
                        );
                    }))
                )
                    return;
                if (this.isStopped || this.isLocked) return void v.preventDefault();
                if (
                    ((this.isSmooth = (this.options.syncTouch && T) || (this.options.smoothWheel && R)), !this.isSmooth)
                )
                    return (this.isScrolling = !1), void this.animate.stop();
                v.preventDefault();
                let O = g;
                this.options.gestureOrientation === "both"
                    ? (O = Math.abs(g) > Math.abs(c) ? g : c)
                    : this.options.gestureOrientation === "horizontal" && (O = c);
                const D = T && this.options.syncTouch,
                    N = T && v.type === "touchend" && Math.abs(O) > 5;
                N && (O = this.velocity * this.options.touchInertiaMultiplier),
                    this.scrollTo(
                        this.targetScroll + O,
                        Object.assign(
                            { programmatic: !1 },
                            D
                                ? { lerp: N ? this.options.syncTouchLerp : 1 }
                                : {
                                      lerp: this.options.lerp,
                                      duration: this.options.duration,
                                      easing: this.options.easing,
                                  }
                        )
                    );
            }),
            (this.onNativeScroll = () => {
                if (!this.__preventNextScrollEvent && !this.isScrolling) {
                    const c = this.animatedScroll;
                    (this.animatedScroll = this.targetScroll = this.actualScroll),
                        (this.velocity = 0),
                        (this.direction = Math.sign(this.animatedScroll - c)),
                        this.emit();
                }
            }),
            (window.lenisVersion = "1.0.39"),
            (t !== document.documentElement && t !== document.body) || (t = window),
            (this.options = {
                wrapper: t,
                content: r,
                wheelEventsTarget: i,
                eventsTarget: n,
                smoothWheel: o,
                syncTouch: a,
                syncTouchLerp: s,
                touchInertiaMultiplier: l,
                duration: u,
                easing: d,
                lerp: p,
                infinite: y,
                gestureOrientation: b,
                orientation: m,
                touchMultiplier: S,
                wheelMultiplier: w,
                normalizeWheel: h,
                autoResize: E,
                __experimental__naiveDimensions: _,
            }),
            (this.animate = new kr()),
            (this.emitter = new or()),
            (this.dimensions = new Dr({ wrapper: t, content: r, autoResize: E })),
            this.toggleClassName("lenis", !0),
            (this.velocity = 0),
            (this.isLocked = !1),
            (this.isStopped = !1),
            (this.isSmooth = a || o),
            (this.isScrolling = !1),
            (this.targetScroll = this.animatedScroll = this.actualScroll),
            this.options.wrapper.addEventListener("scroll", this.onNativeScroll, { passive: !1 }),
            (this.virtualScroll = new Rr(n, { touchMultiplier: S, wheelMultiplier: w, normalizeWheel: h })),
            this.virtualScroll.on("scroll", this.onVirtualScroll);
    }
    destroy() {
        this.emitter.destroy(),
            this.options.wrapper.removeEventListener("scroll", this.onNativeScroll, { passive: !1 }),
            this.virtualScroll.destroy(),
            this.dimensions.destroy(),
            this.toggleClassName("lenis", !1),
            this.toggleClassName("lenis-smooth", !1),
            this.toggleClassName("lenis-scrolling", !1),
            this.toggleClassName("lenis-stopped", !1),
            this.toggleClassName("lenis-locked", !1);
    }
    on(t, r) {
        return this.emitter.on(t, r);
    }
    off(t, r) {
        return this.emitter.off(t, r);
    }
    setScroll(t) {
        this.isHorizontal ? (this.rootElement.scrollLeft = t) : (this.rootElement.scrollTop = t);
    }
    resize() {
        this.dimensions.resize();
    }
    emit() {
        this.emitter.emit("scroll", this);
    }
    reset() {
        (this.isLocked = !1),
            (this.isScrolling = !1),
            (this.animatedScroll = this.targetScroll = this.actualScroll),
            (this.velocity = 0),
            this.animate.stop();
    }
    start() {
        this.isStopped && ((this.isStopped = !1), this.reset());
    }
    stop() {
        this.isStopped || ((this.isStopped = !0), this.animate.stop(), this.reset());
    }
    raf(t) {
        const r = t - (this.time || t);
        (this.time = t), this.animate.advance(0.001 * r);
    }
    scrollTo(
        t,
        {
            offset: r = 0,
            immediate: i = !1,
            lock: n = !1,
            duration: o = this.options.duration,
            easing: a = this.options.easing,
            lerp: s = !o && this.options.lerp,
            onComplete: l,
            force: u = !1,
            programmatic: d = !0,
        } = {}
    ) {
        if ((!this.isStopped && !this.isLocked) || u) {
            if (["top", "left", "start"].includes(t)) t = 0;
            else if (["bottom", "right", "end"].includes(t)) t = this.limit;
            else {
                let p;
                if ((typeof t == "string" ? (p = document.querySelector(t)) : t != null && t.nodeType && (p = t), p)) {
                    if (this.options.wrapper !== window) {
                        const m = this.options.wrapper.getBoundingClientRect();
                        r -= this.isHorizontal ? m.left : m.top;
                    }
                    const y = p.getBoundingClientRect();
                    t = (this.isHorizontal ? y.left : y.top) + this.animatedScroll;
                }
            }
            if (typeof t == "number") {
                if (
                    ((t += r),
                    (t = Math.round(t)),
                    this.options.infinite
                        ? d && (this.targetScroll = this.animatedScroll = this.scroll)
                        : (t = at(0, t, this.limit)),
                    i)
                )
                    return (
                        (this.animatedScroll = this.targetScroll = t),
                        this.setScroll(this.scroll),
                        this.reset(),
                        void (l == null || l(this))
                    );
                if (!d) {
                    if (t === this.targetScroll) return;
                    this.targetScroll = t;
                }
                this.animate.fromTo(this.animatedScroll, t, {
                    duration: o,
                    easing: a,
                    lerp: s,
                    onStart: () => {
                        n && (this.isLocked = !0), (this.isScrolling = !0);
                    },
                    onUpdate: (p, y) => {
                        (this.isScrolling = !0),
                            (this.velocity = p - this.animatedScroll),
                            (this.direction = Math.sign(this.velocity)),
                            (this.animatedScroll = p),
                            this.setScroll(this.scroll),
                            d && (this.targetScroll = p),
                            y || this.emit(),
                            y &&
                                (this.reset(),
                                this.emit(),
                                l == null || l(this),
                                (this.__preventNextScrollEvent = !0),
                                requestAnimationFrame(() => {
                                    delete this.__preventNextScrollEvent;
                                }));
                    },
                });
            }
        }
    }
    get rootElement() {
        return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    get limit() {
        return this.options.__experimental__naiveDimensions
            ? this.isHorizontal
                ? this.rootElement.scrollWidth - this.rootElement.clientWidth
                : this.rootElement.scrollHeight - this.rootElement.clientHeight
            : this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    get isHorizontal() {
        return this.options.orientation === "horizontal";
    }
    get actualScroll() {
        return this.isHorizontal ? this.rootElement.scrollLeft : this.rootElement.scrollTop;
    }
    get scroll() {
        return this.options.infinite
            ? ((t = this.animatedScroll), (r = this.limit), ((t % r) + r) % r)
            : this.animatedScroll;
        var t, r;
    }
    get progress() {
        return this.limit === 0 ? 1 : this.scroll / this.limit;
    }
    get isSmooth() {
        return this.__isSmooth;
    }
    set isSmooth(t) {
        this.__isSmooth !== t && ((this.__isSmooth = t), this.toggleClassName("lenis-smooth", t));
    }
    get isScrolling() {
        return this.__isScrolling;
    }
    set isScrolling(t) {
        this.__isScrolling !== t && ((this.__isScrolling = t), this.toggleClassName("lenis-scrolling", t));
    }
    get isStopped() {
        return this.__isStopped;
    }
    set isStopped(t) {
        this.__isStopped !== t && ((this.__isStopped = t), this.toggleClassName("lenis-stopped", t));
    }
    get isLocked() {
        return this.__isLocked;
    }
    set isLocked(t) {
        this.__isLocked !== t && ((this.__isLocked = t), this.toggleClassName("lenis-locked", t));
    }
    get className() {
        let t = "lenis";
        return (
            this.isStopped && (t += " lenis-stopped"),
            this.isLocked && (t += " lenis-locked"),
            this.isScrolling && (t += " lenis-scrolling"),
            this.isSmooth && (t += " lenis-smooth"),
            t
        );
    }
    toggleClassName(t, r) {
        this.rootElement.classList.toggle(t, r), this.emitter.emit("className change", this);
    }
}
function Hr(e, t) {
    for (var r = 0; r < t.length; r++) {
        var i = t[r];
        (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, i.key, i);
    }
}
function rt(e) {
    return (
        (function (t) {
            if (Array.isArray(t)) return ht(t);
        })(e) ||
        (function (t) {
            if (typeof Symbol < "u" && Symbol.iterator in Object(t)) return Array.from(t);
        })(e) ||
        (function (t, r) {
            if (t) {
                if (typeof t == "string") return ht(t, r);
                var i = Object.prototype.toString.call(t).slice(8, -1);
                if ((i === "Object" && t.constructor && (i = t.constructor.name), i === "Map" || i === "Set"))
                    return Array.from(t);
                if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return ht(t, r);
            }
        })(e) ||
        (function () {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        })()
    );
}
function ht(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, i = new Array(t); r < t; r++) i[r] = e[r];
    return i;
}
var It,
    vt,
    ve,
    mt,
    Nt,
    Ot =
        ((It = [
            "a[href]",
            "area[href]",
            'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
            "select:not([disabled]):not([aria-hidden])",
            "textarea:not([disabled]):not([aria-hidden])",
            "button:not([disabled]):not([aria-hidden])",
            "iframe",
            "object",
            "embed",
            "[contenteditable]",
            '[tabindex]:not([tabindex^="-"])',
        ]),
        (vt = (function () {
            function e(i) {
                var n = i.targetModal,
                    o = i.triggers,
                    a = o === void 0 ? [] : o,
                    s = i.onShow,
                    l = s === void 0 ? function () {} : s,
                    u = i.onClose,
                    d = u === void 0 ? function () {} : u,
                    p = i.openTrigger,
                    y = p === void 0 ? "data-micromodal-trigger" : p,
                    m = i.closeTrigger,
                    b = m === void 0 ? "data-micromodal-close" : m,
                    S = i.openClass,
                    w = S === void 0 ? "is-open" : S,
                    h = i.disableScroll,
                    E = h !== void 0 && h,
                    _ = i.disableFocus,
                    c = _ !== void 0 && _,
                    g = i.awaitCloseAnimation,
                    v = g !== void 0 && g,
                    T = i.awaitOpenAnimation,
                    R = T !== void 0 && T,
                    k = i.debugMode,
                    C = k !== void 0 && k;
                (function (M, O) {
                    if (!(M instanceof O)) throw new TypeError("Cannot call a class as a function");
                })(this, e),
                    (this.modal = document.getElementById(n)),
                    (this.config = {
                        debugMode: C,
                        disableScroll: E,
                        openTrigger: y,
                        closeTrigger: b,
                        openClass: w,
                        onShow: l,
                        onClose: d,
                        awaitCloseAnimation: v,
                        awaitOpenAnimation: R,
                        disableFocus: c,
                    }),
                    a.length > 0 && this.registerTriggers.apply(this, rt(a)),
                    (this.onClick = this.onClick.bind(this)),
                    (this.onKeydown = this.onKeydown.bind(this));
            }
            var t, r;
            return (
                (t = e),
                (r = [
                    {
                        key: "registerTriggers",
                        value: function () {
                            for (var i = this, n = arguments.length, o = new Array(n), a = 0; a < n; a++)
                                o[a] = arguments[a];
                            o.filter(Boolean).forEach(function (s) {
                                s.addEventListener("click", function (l) {
                                    return i.showModal(l);
                                });
                            });
                        },
                    },
                    {
                        key: "showModal",
                        value: function () {
                            var i = this,
                                n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                            if (
                                ((this.activeElement = document.activeElement),
                                this.modal.setAttribute("aria-hidden", "false"),
                                this.modal.classList.add(this.config.openClass),
                                this.scrollBehaviour("disable"),
                                this.addEventListeners(),
                                this.config.awaitOpenAnimation)
                            ) {
                                var o = function a() {
                                    i.modal.removeEventListener("animationend", a, !1), i.setFocusToFirstNode();
                                };
                                this.modal.addEventListener("animationend", o, !1);
                            } else this.setFocusToFirstNode();
                            this.config.onShow(this.modal, this.activeElement, n);
                        },
                    },
                    {
                        key: "closeModal",
                        value: function () {
                            var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null,
                                n = this.modal;
                            if (
                                (this.modal.setAttribute("aria-hidden", "true"),
                                this.removeEventListeners(),
                                this.scrollBehaviour("enable"),
                                this.activeElement && this.activeElement.focus && this.activeElement.focus(),
                                this.config.onClose(this.modal, this.activeElement, i),
                                this.config.awaitCloseAnimation)
                            ) {
                                var o = this.config.openClass;
                                this.modal.addEventListener(
                                    "animationend",
                                    function a() {
                                        n.classList.remove(o), n.removeEventListener("animationend", a, !1);
                                    },
                                    !1
                                );
                            } else n.classList.remove(this.config.openClass);
                        },
                    },
                    {
                        key: "closeModalById",
                        value: function (i) {
                            (this.modal = document.getElementById(i)), this.modal && this.closeModal();
                        },
                    },
                    {
                        key: "scrollBehaviour",
                        value: function (i) {
                            if (this.config.disableScroll) {
                                var n = document.querySelector("body");
                                switch (i) {
                                    case "enable":
                                        Object.assign(n.style, { overflow: "" });
                                        break;
                                    case "disable":
                                        Object.assign(n.style, { overflow: "hidden" });
                                }
                            }
                        },
                    },
                    {
                        key: "addEventListeners",
                        value: function () {
                            this.modal.addEventListener("touchstart", this.onClick),
                                this.modal.addEventListener("click", this.onClick),
                                document.addEventListener("keydown", this.onKeydown);
                        },
                    },
                    {
                        key: "removeEventListeners",
                        value: function () {
                            this.modal.removeEventListener("touchstart", this.onClick),
                                this.modal.removeEventListener("click", this.onClick),
                                document.removeEventListener("keydown", this.onKeydown);
                        },
                    },
                    {
                        key: "onClick",
                        value: function (i) {
                            (i.target.hasAttribute(this.config.closeTrigger) ||
                                i.target.parentNode.hasAttribute(this.config.closeTrigger)) &&
                                (i.preventDefault(), i.stopPropagation(), this.closeModal(i));
                        },
                    },
                    {
                        key: "onKeydown",
                        value: function (i) {
                            i.keyCode === 27 && this.closeModal(i), i.keyCode === 9 && this.retainFocus(i);
                        },
                    },
                    {
                        key: "getFocusableNodes",
                        value: function () {
                            var i = this.modal.querySelectorAll(It);
                            return Array.apply(void 0, rt(i));
                        },
                    },
                    {
                        key: "setFocusToFirstNode",
                        value: function () {
                            var i = this;
                            if (!this.config.disableFocus) {
                                var n = this.getFocusableNodes();
                                if (n.length !== 0) {
                                    var o = n.filter(function (a) {
                                        return !a.hasAttribute(i.config.closeTrigger);
                                    });
                                    o.length > 0 && o[0].focus(), o.length === 0 && n[0].focus();
                                }
                            }
                        },
                    },
                    {
                        key: "retainFocus",
                        value: function (i) {
                            var n = this.getFocusableNodes();
                            if (n.length !== 0)
                                if (
                                    ((n = n.filter(function (a) {
                                        return a.offsetParent !== null;
                                    })),
                                    this.modal.contains(document.activeElement))
                                ) {
                                    var o = n.indexOf(document.activeElement);
                                    i.shiftKey && o === 0 && (n[n.length - 1].focus(), i.preventDefault()),
                                        !i.shiftKey &&
                                            n.length > 0 &&
                                            o === n.length - 1 &&
                                            (n[0].focus(), i.preventDefault());
                                } else n[0].focus();
                        },
                    },
                ]) && Hr(t.prototype, r),
                e
            );
        })()),
        (ve = null),
        (mt = function (e) {
            if (!document.getElementById(e))
                return (
                    console.warn(
                        "MicroModal: ❗Seems like you have missed %c'".concat(e, "'"),
                        "background-color: #f8f9fa;color: #50596c;font-weight: bold;",
                        "ID somewhere in your code. Refer example below to resolve it."
                    ),
                    console.warn(
                        "%cExample:",
                        "background-color: #f8f9fa;color: #50596c;font-weight: bold;",
                        '<div class="modal" id="'.concat(e, '"></div>')
                    ),
                    !1
                );
        }),
        (Nt = function (e, t) {
            if (
                ((function (i) {
                    i.length <= 0 &&
                        (console.warn(
                            "MicroModal: ❗Please specify at least one %c'micromodal-trigger'",
                            "background-color: #f8f9fa;color: #50596c;font-weight: bold;",
                            "data attribute."
                        ),
                        console.warn(
                            "%cExample:",
                            "background-color: #f8f9fa;color: #50596c;font-weight: bold;",
                            '<a href="#" data-micromodal-trigger="my-modal"></a>'
                        ));
                })(e),
                !t)
            )
                return !0;
            for (var r in t) mt(r);
            return !0;
        }),
        {
            init: function (e) {
                var t = Object.assign({}, { openTrigger: "data-micromodal-trigger" }, e),
                    r = rt(document.querySelectorAll("[".concat(t.openTrigger, "]"))),
                    i = (function (a, s) {
                        var l = [];
                        return (
                            a.forEach(function (u) {
                                var d = u.attributes[s].value;
                                l[d] === void 0 && (l[d] = []), l[d].push(u);
                            }),
                            l
                        );
                    })(r, t.openTrigger);
                if (t.debugMode !== !0 || Nt(r, i) !== !1)
                    for (var n in i) {
                        var o = i[n];
                        (t.targetModal = n), (t.triggers = rt(o)), (ve = new vt(t));
                    }
            },
            show: function (e, t) {
                var r = t || {};
                (r.targetModal = e),
                    (r.debugMode === !0 && mt(e) === !1) ||
                        (ve && ve.removeEventListeners(), (ve = new vt(r)).showModal());
            },
            close: function (e) {
                e ? ve.closeModalById(e) : ve.closeModal();
            },
        });
typeof window < "u" && (window.MicroModal = Ot);
var j = "top",
    X = "bottom",
    G = "right",
    z = "left",
    qt = "auto",
    je = [j, X, G, z],
    Te = "start",
    We = "end",
    $r = "clippingParents",
    sr = "viewport",
    He = "popper",
    Ir = "reference",
    Bt = je.reduce(function (e, t) {
        return e.concat([t + "-" + Te, t + "-" + We]);
    }, []),
    ar = [].concat(je, [qt]).reduce(function (e, t) {
        return e.concat([t, t + "-" + Te, t + "-" + We]);
    }, []),
    Nr = "beforeRead",
    Br = "read",
    Wr = "afterRead",
    Fr = "beforeMain",
    jr = "main",
    zr = "afterMain",
    Ur = "beforeWrite",
    Vr = "write",
    Yr = "afterWrite",
    Xr = [Nr, Br, Wr, Fr, jr, zr, Ur, Vr, Yr];
function te(e) {
    return e ? (e.nodeName || "").toLowerCase() : null;
}
function U(e) {
    if (e == null) return window;
    if (e.toString() !== "[object Window]") {
        var t = e.ownerDocument;
        return (t && t.defaultView) || window;
    }
    return e;
}
function ye(e) {
    var t = U(e).Element;
    return e instanceof t || e instanceof Element;
}
function Y(e) {
    var t = U(e).HTMLElement;
    return e instanceof t || e instanceof HTMLElement;
}
function Ct(e) {
    if (typeof ShadowRoot > "u") return !1;
    var t = U(e).ShadowRoot;
    return e instanceof t || e instanceof ShadowRoot;
}
function Gr(e) {
    var t = e.state;
    Object.keys(t.elements).forEach(function (r) {
        var i = t.styles[r] || {},
            n = t.attributes[r] || {},
            o = t.elements[r];
        !Y(o) ||
            !te(o) ||
            (Object.assign(o.style, i),
            Object.keys(n).forEach(function (a) {
                var s = n[a];
                s === !1 ? o.removeAttribute(a) : o.setAttribute(a, s === !0 ? "" : s);
            }));
    });
}
function Kr(e) {
    var t = e.state,
        r = {
            popper: { position: t.options.strategy, left: "0", top: "0", margin: "0" },
            arrow: { position: "absolute" },
            reference: {},
        };
    return (
        Object.assign(t.elements.popper.style, r.popper),
        (t.styles = r),
        t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow),
        function () {
            Object.keys(t.elements).forEach(function (i) {
                var n = t.elements[i],
                    o = t.attributes[i] || {},
                    a = Object.keys(t.styles.hasOwnProperty(i) ? t.styles[i] : r[i]),
                    s = a.reduce(function (l, u) {
                        return (l[u] = ""), l;
                    }, {});
                !Y(n) ||
                    !te(n) ||
                    (Object.assign(n.style, s),
                    Object.keys(o).forEach(function (l) {
                        n.removeAttribute(l);
                    }));
            });
        }
    );
}
const lr = { name: "applyStyles", enabled: !0, phase: "write", fn: Gr, effect: Kr, requires: ["computeStyles"] };
function ee(e) {
    return e.split("-")[0];
}
var ge = Math.max,
    lt = Math.min,
    xe = Math.round;
function _t() {
    var e = navigator.userAgentData;
    return e != null && e.brands && Array.isArray(e.brands)
        ? e.brands
              .map(function (t) {
                  return t.brand + "/" + t.version;
              })
              .join(" ")
        : navigator.userAgent;
}
function cr() {
    return !/^((?!chrome|android).)*safari/i.test(_t());
}
function Oe(e, t, r) {
    t === void 0 && (t = !1), r === void 0 && (r = !1);
    var i = e.getBoundingClientRect(),
        n = 1,
        o = 1;
    t &&
        Y(e) &&
        ((n = (e.offsetWidth > 0 && xe(i.width) / e.offsetWidth) || 1),
        (o = (e.offsetHeight > 0 && xe(i.height) / e.offsetHeight) || 1));
    var a = ye(e) ? U(e) : window,
        s = a.visualViewport,
        l = !cr() && r,
        u = (i.left + (l && s ? s.offsetLeft : 0)) / n,
        d = (i.top + (l && s ? s.offsetTop : 0)) / o,
        p = i.width / n,
        y = i.height / o;
    return { width: p, height: y, top: d, right: u + p, bottom: d + y, left: u, x: u, y: d };
}
function Mt(e) {
    var t = Oe(e),
        r = e.offsetWidth,
        i = e.offsetHeight;
    return (
        Math.abs(t.width - r) <= 1 && (r = t.width),
        Math.abs(t.height - i) <= 1 && (i = t.height),
        { x: e.offsetLeft, y: e.offsetTop, width: r, height: i }
    );
}
function ur(e, t) {
    var r = t.getRootNode && t.getRootNode();
    if (e.contains(t)) return !0;
    if (r && Ct(r)) {
        var i = t;
        do {
            if (i && e.isSameNode(i)) return !0;
            i = i.parentNode || i.host;
        } while (i);
    }
    return !1;
}
function se(e) {
    return U(e).getComputedStyle(e);
}
function Jr(e) {
    return ["table", "td", "th"].indexOf(te(e)) >= 0;
}
function ue(e) {
    return ((ye(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function ut(e) {
    return te(e) === "html" ? e : e.assignedSlot || e.parentNode || (Ct(e) ? e.host : null) || ue(e);
}
function Wt(e) {
    return !Y(e) || se(e).position === "fixed" ? null : e.offsetParent;
}
function Qr(e) {
    var t = /firefox/i.test(_t()),
        r = /Trident/i.test(_t());
    if (r && Y(e)) {
        var i = se(e);
        if (i.position === "fixed") return null;
    }
    var n = ut(e);
    for (Ct(n) && (n = n.host); Y(n) && ["html", "body"].indexOf(te(n)) < 0; ) {
        var o = se(n);
        if (
            o.transform !== "none" ||
            o.perspective !== "none" ||
            o.contain === "paint" ||
            ["transform", "perspective"].indexOf(o.willChange) !== -1 ||
            (t && o.willChange === "filter") ||
            (t && o.filter && o.filter !== "none")
        )
            return n;
        n = n.parentNode;
    }
    return null;
}
function ze(e) {
    for (var t = U(e), r = Wt(e); r && Jr(r) && se(r).position === "static"; ) r = Wt(r);
    return r && (te(r) === "html" || (te(r) === "body" && se(r).position === "static")) ? t : r || Qr(e) || t;
}
function kt(e) {
    return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Ie(e, t, r) {
    return ge(e, lt(t, r));
}
function Zr(e, t, r) {
    var i = Ie(e, t, r);
    return i > r ? r : i;
}
function dr() {
    return { top: 0, right: 0, bottom: 0, left: 0 };
}
function fr(e) {
    return Object.assign({}, dr(), e);
}
function pr(e, t) {
    return t.reduce(function (r, i) {
        return (r[i] = e), r;
    }, {});
}
var ei = function (t, r) {
    return (
        (t = typeof t == "function" ? t(Object.assign({}, r.rects, { placement: r.placement })) : t),
        fr(typeof t != "number" ? t : pr(t, je))
    );
};
function ti(e) {
    var t,
        r = e.state,
        i = e.name,
        n = e.options,
        o = r.elements.arrow,
        a = r.modifiersData.popperOffsets,
        s = ee(r.placement),
        l = kt(s),
        u = [z, G].indexOf(s) >= 0,
        d = u ? "height" : "width";
    if (!(!o || !a)) {
        var p = ei(n.padding, r),
            y = Mt(o),
            m = l === "y" ? j : z,
            b = l === "y" ? X : G,
            S = r.rects.reference[d] + r.rects.reference[l] - a[l] - r.rects.popper[d],
            w = a[l] - r.rects.reference[l],
            h = ze(o),
            E = h ? (l === "y" ? h.clientHeight || 0 : h.clientWidth || 0) : 0,
            _ = S / 2 - w / 2,
            c = p[m],
            g = E - y[d] - p[b],
            v = E / 2 - y[d] / 2 + _,
            T = Ie(c, v, g),
            R = l;
        r.modifiersData[i] = ((t = {}), (t[R] = T), (t.centerOffset = T - v), t);
    }
}
function ri(e) {
    var t = e.state,
        r = e.options,
        i = r.element,
        n = i === void 0 ? "[data-popper-arrow]" : i;
    n != null &&
        ((typeof n == "string" && ((n = t.elements.popper.querySelector(n)), !n)) ||
            (ur(t.elements.popper, n) && (t.elements.arrow = n)));
}
const ii = {
    name: "arrow",
    enabled: !0,
    phase: "main",
    fn: ti,
    effect: ri,
    requires: ["popperOffsets"],
    requiresIfExists: ["preventOverflow"],
};
function qe(e) {
    return e.split("-")[1];
}
var ni = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
function oi(e, t) {
    var r = e.x,
        i = e.y,
        n = t.devicePixelRatio || 1;
    return { x: xe(r * n) / n || 0, y: xe(i * n) / n || 0 };
}
function Ft(e) {
    var t,
        r = e.popper,
        i = e.popperRect,
        n = e.placement,
        o = e.variation,
        a = e.offsets,
        s = e.position,
        l = e.gpuAcceleration,
        u = e.adaptive,
        d = e.roundOffsets,
        p = e.isFixed,
        y = a.x,
        m = y === void 0 ? 0 : y,
        b = a.y,
        S = b === void 0 ? 0 : b,
        w = typeof d == "function" ? d({ x: m, y: S }) : { x: m, y: S };
    (m = w.x), (S = w.y);
    var h = a.hasOwnProperty("x"),
        E = a.hasOwnProperty("y"),
        _ = z,
        c = j,
        g = window;
    if (u) {
        var v = ze(r),
            T = "clientHeight",
            R = "clientWidth";
        if (
            (v === U(r) &&
                ((v = ue(r)),
                se(v).position !== "static" && s === "absolute" && ((T = "scrollHeight"), (R = "scrollWidth"))),
            (v = v),
            n === j || ((n === z || n === G) && o === We))
        ) {
            c = X;
            var k = p && v === g && g.visualViewport ? g.visualViewport.height : v[T];
            (S -= k - i.height), (S *= l ? 1 : -1);
        }
        if (n === z || ((n === j || n === X) && o === We)) {
            _ = G;
            var C = p && v === g && g.visualViewport ? g.visualViewport.width : v[R];
            (m -= C - i.width), (m *= l ? 1 : -1);
        }
    }
    var M = Object.assign({ position: s }, u && ni),
        O = d === !0 ? oi({ x: m, y: S }, U(r)) : { x: m, y: S };
    if (((m = O.x), (S = O.y), l)) {
        var D;
        return Object.assign(
            {},
            M,
            ((D = {}),
            (D[c] = E ? "0" : ""),
            (D[_] = h ? "0" : ""),
            (D.transform =
                (g.devicePixelRatio || 1) <= 1
                    ? "translate(" + m + "px, " + S + "px)"
                    : "translate3d(" + m + "px, " + S + "px, 0)"),
            D)
        );
    }
    return Object.assign(
        {},
        M,
        ((t = {}), (t[c] = E ? S + "px" : ""), (t[_] = h ? m + "px" : ""), (t.transform = ""), t)
    );
}
function si(e) {
    var t = e.state,
        r = e.options,
        i = r.gpuAcceleration,
        n = i === void 0 ? !0 : i,
        o = r.adaptive,
        a = o === void 0 ? !0 : o,
        s = r.roundOffsets,
        l = s === void 0 ? !0 : s,
        u = {
            placement: ee(t.placement),
            variation: qe(t.placement),
            popper: t.elements.popper,
            popperRect: t.rects.popper,
            gpuAcceleration: n,
            isFixed: t.options.strategy === "fixed",
        };
    t.modifiersData.popperOffsets != null &&
        (t.styles.popper = Object.assign(
            {},
            t.styles.popper,
            Ft(
                Object.assign({}, u, {
                    offsets: t.modifiersData.popperOffsets,
                    position: t.options.strategy,
                    adaptive: a,
                    roundOffsets: l,
                })
            )
        )),
        t.modifiersData.arrow != null &&
            (t.styles.arrow = Object.assign(
                {},
                t.styles.arrow,
                Ft(
                    Object.assign({}, u, {
                        offsets: t.modifiersData.arrow,
                        position: "absolute",
                        adaptive: !1,
                        roundOffsets: l,
                    })
                )
            )),
        (t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-placement": t.placement }));
}
const ai = { name: "computeStyles", enabled: !0, phase: "beforeWrite", fn: si, data: {} };
var it = { passive: !0 };
function li(e) {
    var t = e.state,
        r = e.instance,
        i = e.options,
        n = i.scroll,
        o = n === void 0 ? !0 : n,
        a = i.resize,
        s = a === void 0 ? !0 : a,
        l = U(t.elements.popper),
        u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
    return (
        o &&
            u.forEach(function (d) {
                d.addEventListener("scroll", r.update, it);
            }),
        s && l.addEventListener("resize", r.update, it),
        function () {
            o &&
                u.forEach(function (d) {
                    d.removeEventListener("scroll", r.update, it);
                }),
                s && l.removeEventListener("resize", r.update, it);
        }
    );
}
const ci = { name: "eventListeners", enabled: !0, phase: "write", fn: function () {}, effect: li, data: {} };
var ui = { left: "right", right: "left", bottom: "top", top: "bottom" };
function st(e) {
    return e.replace(/left|right|bottom|top/g, function (t) {
        return ui[t];
    });
}
var di = { start: "end", end: "start" };
function jt(e) {
    return e.replace(/start|end/g, function (t) {
        return di[t];
    });
}
function Dt(e) {
    var t = U(e),
        r = t.pageXOffset,
        i = t.pageYOffset;
    return { scrollLeft: r, scrollTop: i };
}
function Rt(e) {
    return Oe(ue(e)).left + Dt(e).scrollLeft;
}
function fi(e, t) {
    var r = U(e),
        i = ue(e),
        n = r.visualViewport,
        o = i.clientWidth,
        a = i.clientHeight,
        s = 0,
        l = 0;
    if (n) {
        (o = n.width), (a = n.height);
        var u = cr();
        (u || (!u && t === "fixed")) && ((s = n.offsetLeft), (l = n.offsetTop));
    }
    return { width: o, height: a, x: s + Rt(e), y: l };
}
function pi(e) {
    var t,
        r = ue(e),
        i = Dt(e),
        n = (t = e.ownerDocument) == null ? void 0 : t.body,
        o = ge(r.scrollWidth, r.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0),
        a = ge(r.scrollHeight, r.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0),
        s = -i.scrollLeft + Rt(e),
        l = -i.scrollTop;
    return (
        se(n || r).direction === "rtl" && (s += ge(r.clientWidth, n ? n.clientWidth : 0) - o),
        { width: o, height: a, x: s, y: l }
    );
}
function Pt(e) {
    var t = se(e),
        r = t.overflow,
        i = t.overflowX,
        n = t.overflowY;
    return /auto|scroll|overlay|hidden/.test(r + n + i);
}
function hr(e) {
    return ["html", "body", "#document"].indexOf(te(e)) >= 0 ? e.ownerDocument.body : Y(e) && Pt(e) ? e : hr(ut(e));
}
function Ne(e, t) {
    var r;
    t === void 0 && (t = []);
    var i = hr(e),
        n = i === ((r = e.ownerDocument) == null ? void 0 : r.body),
        o = U(i),
        a = n ? [o].concat(o.visualViewport || [], Pt(i) ? i : []) : i,
        s = t.concat(a);
    return n ? s : s.concat(Ne(ut(a)));
}
function At(e) {
    return Object.assign({}, e, { left: e.x, top: e.y, right: e.x + e.width, bottom: e.y + e.height });
}
function hi(e, t) {
    var r = Oe(e, !1, t === "fixed");
    return (
        (r.top = r.top + e.clientTop),
        (r.left = r.left + e.clientLeft),
        (r.bottom = r.top + e.clientHeight),
        (r.right = r.left + e.clientWidth),
        (r.width = e.clientWidth),
        (r.height = e.clientHeight),
        (r.x = r.left),
        (r.y = r.top),
        r
    );
}
function zt(e, t, r) {
    return t === sr ? At(fi(e, r)) : ye(t) ? hi(t, r) : At(pi(ue(e)));
}
function vi(e) {
    var t = Ne(ut(e)),
        r = ["absolute", "fixed"].indexOf(se(e).position) >= 0,
        i = r && Y(e) ? ze(e) : e;
    return ye(i)
        ? t.filter(function (n) {
              return ye(n) && ur(n, i) && te(n) !== "body";
          })
        : [];
}
function mi(e, t, r, i) {
    var n = t === "clippingParents" ? vi(e) : [].concat(t),
        o = [].concat(n, [r]),
        a = o[0],
        s = o.reduce(
            function (l, u) {
                var d = zt(e, u, i);
                return (
                    (l.top = ge(d.top, l.top)),
                    (l.right = lt(d.right, l.right)),
                    (l.bottom = lt(d.bottom, l.bottom)),
                    (l.left = ge(d.left, l.left)),
                    l
                );
            },
            zt(e, a, i)
        );
    return (s.width = s.right - s.left), (s.height = s.bottom - s.top), (s.x = s.left), (s.y = s.top), s;
}
function vr(e) {
    var t = e.reference,
        r = e.element,
        i = e.placement,
        n = i ? ee(i) : null,
        o = i ? qe(i) : null,
        a = t.x + t.width / 2 - r.width / 2,
        s = t.y + t.height / 2 - r.height / 2,
        l;
    switch (n) {
        case j:
            l = { x: a, y: t.y - r.height };
            break;
        case X:
            l = { x: a, y: t.y + t.height };
            break;
        case G:
            l = { x: t.x + t.width, y: s };
            break;
        case z:
            l = { x: t.x - r.width, y: s };
            break;
        default:
            l = { x: t.x, y: t.y };
    }
    var u = n ? kt(n) : null;
    if (u != null) {
        var d = u === "y" ? "height" : "width";
        switch (o) {
            case Te:
                l[u] = l[u] - (t[d] / 2 - r[d] / 2);
                break;
            case We:
                l[u] = l[u] + (t[d] / 2 - r[d] / 2);
                break;
        }
    }
    return l;
}
function Fe(e, t) {
    t === void 0 && (t = {});
    var r = t,
        i = r.placement,
        n = i === void 0 ? e.placement : i,
        o = r.strategy,
        a = o === void 0 ? e.strategy : o,
        s = r.boundary,
        l = s === void 0 ? $r : s,
        u = r.rootBoundary,
        d = u === void 0 ? sr : u,
        p = r.elementContext,
        y = p === void 0 ? He : p,
        m = r.altBoundary,
        b = m === void 0 ? !1 : m,
        S = r.padding,
        w = S === void 0 ? 0 : S,
        h = fr(typeof w != "number" ? w : pr(w, je)),
        E = y === He ? Ir : He,
        _ = e.rects.popper,
        c = e.elements[b ? E : y],
        g = mi(ye(c) ? c : c.contextElement || ue(e.elements.popper), l, d, a),
        v = Oe(e.elements.reference),
        T = vr({ reference: v, element: _, strategy: "absolute", placement: n }),
        R = At(Object.assign({}, _, T)),
        k = y === He ? R : v,
        C = {
            top: g.top - k.top + h.top,
            bottom: k.bottom - g.bottom + h.bottom,
            left: g.left - k.left + h.left,
            right: k.right - g.right + h.right,
        },
        M = e.modifiersData.offset;
    if (y === He && M) {
        var O = M[n];
        Object.keys(C).forEach(function (D) {
            var N = [G, X].indexOf(D) >= 0 ? 1 : -1,
                P = [j, X].indexOf(D) >= 0 ? "y" : "x";
            C[D] += O[P] * N;
        });
    }
    return C;
}
function gi(e, t) {
    t === void 0 && (t = {});
    var r = t,
        i = r.placement,
        n = r.boundary,
        o = r.rootBoundary,
        a = r.padding,
        s = r.flipVariations,
        l = r.allowedAutoPlacements,
        u = l === void 0 ? ar : l,
        d = qe(i),
        p = d
            ? s
                ? Bt
                : Bt.filter(function (b) {
                      return qe(b) === d;
                  })
            : je,
        y = p.filter(function (b) {
            return u.indexOf(b) >= 0;
        });
    y.length === 0 && (y = p);
    var m = y.reduce(function (b, S) {
        return (b[S] = Fe(e, { placement: S, boundary: n, rootBoundary: o, padding: a })[ee(S)]), b;
    }, {});
    return Object.keys(m).sort(function (b, S) {
        return m[b] - m[S];
    });
}
function yi(e) {
    if (ee(e) === qt) return [];
    var t = st(e);
    return [jt(e), t, jt(t)];
}
function wi(e) {
    var t = e.state,
        r = e.options,
        i = e.name;
    if (!t.modifiersData[i]._skip) {
        for (
            var n = r.mainAxis,
                o = n === void 0 ? !0 : n,
                a = r.altAxis,
                s = a === void 0 ? !0 : a,
                l = r.fallbackPlacements,
                u = r.padding,
                d = r.boundary,
                p = r.rootBoundary,
                y = r.altBoundary,
                m = r.flipVariations,
                b = m === void 0 ? !0 : m,
                S = r.allowedAutoPlacements,
                w = t.options.placement,
                h = ee(w),
                E = h === w,
                _ = l || (E || !b ? [st(w)] : yi(w)),
                c = [w].concat(_).reduce(function (re, K) {
                    return re.concat(
                        ee(K) === qt
                            ? gi(t, {
                                  placement: K,
                                  boundary: d,
                                  rootBoundary: p,
                                  padding: u,
                                  flipVariations: b,
                                  allowedAutoPlacements: S,
                              })
                            : K
                    );
                }, []),
                g = t.rects.reference,
                v = t.rects.popper,
                T = new Map(),
                R = !0,
                k = c[0],
                C = 0;
            C < c.length;
            C++
        ) {
            var M = c[C],
                O = ee(M),
                D = qe(M) === Te,
                N = [j, X].indexOf(O) >= 0,
                P = N ? "width" : "height",
                $ = Fe(t, { placement: M, boundary: d, rootBoundary: p, altBoundary: y, padding: u }),
                I = N ? (D ? G : z) : D ? X : j;
            g[P] > v[P] && (I = st(I));
            var H = st(I),
                W = [];
            if (
                (o && W.push($[O] <= 0),
                s && W.push($[I] <= 0, $[H] <= 0),
                W.every(function (re) {
                    return re;
                }))
            ) {
                (k = M), (R = !1);
                break;
            }
            T.set(M, W);
        }
        if (R)
            for (
                var F = b ? 3 : 1,
                    de = function (K) {
                        var ie = c.find(function (we) {
                            var ne = T.get(we);
                            if (ne)
                                return ne.slice(0, K).every(function (be) {
                                    return be;
                                });
                        });
                        if (ie) return (k = ie), "break";
                    },
                    Q = F;
                Q > 0;
                Q--
            ) {
                var fe = de(Q);
                if (fe === "break") break;
            }
        t.placement !== k && ((t.modifiersData[i]._skip = !0), (t.placement = k), (t.reset = !0));
    }
}
const bi = { name: "flip", enabled: !0, phase: "main", fn: wi, requiresIfExists: ["offset"], data: { _skip: !1 } };
function Ut(e, t, r) {
    return (
        r === void 0 && (r = { x: 0, y: 0 }),
        {
            top: e.top - t.height - r.y,
            right: e.right - t.width + r.x,
            bottom: e.bottom - t.height + r.y,
            left: e.left - t.width - r.x,
        }
    );
}
function Vt(e) {
    return [j, G, X, z].some(function (t) {
        return e[t] >= 0;
    });
}
function Si(e) {
    var t = e.state,
        r = e.name,
        i = t.rects.reference,
        n = t.rects.popper,
        o = t.modifiersData.preventOverflow,
        a = Fe(t, { elementContext: "reference" }),
        s = Fe(t, { altBoundary: !0 }),
        l = Ut(a, i),
        u = Ut(s, n, o),
        d = Vt(l),
        p = Vt(u);
    (t.modifiersData[r] = {
        referenceClippingOffsets: l,
        popperEscapeOffsets: u,
        isReferenceHidden: d,
        hasPopperEscaped: p,
    }),
        (t.attributes.popper = Object.assign({}, t.attributes.popper, {
            "data-popper-reference-hidden": d,
            "data-popper-escaped": p,
        }));
}
const Li = { name: "hide", enabled: !0, phase: "main", requiresIfExists: ["preventOverflow"], fn: Si };
function Ei(e, t, r) {
    var i = ee(e),
        n = [z, j].indexOf(i) >= 0 ? -1 : 1,
        o = typeof r == "function" ? r(Object.assign({}, t, { placement: e })) : r,
        a = o[0],
        s = o[1];
    return (a = a || 0), (s = (s || 0) * n), [z, G].indexOf(i) >= 0 ? { x: s, y: a } : { x: a, y: s };
}
function _i(e) {
    var t = e.state,
        r = e.options,
        i = e.name,
        n = r.offset,
        o = n === void 0 ? [0, 0] : n,
        a = ar.reduce(function (d, p) {
            return (d[p] = Ei(p, t.rects, o)), d;
        }, {}),
        s = a[t.placement],
        l = s.x,
        u = s.y;
    t.modifiersData.popperOffsets != null &&
        ((t.modifiersData.popperOffsets.x += l), (t.modifiersData.popperOffsets.y += u)),
        (t.modifiersData[i] = a);
}
const Ai = { name: "offset", enabled: !0, phase: "main", requires: ["popperOffsets"], fn: _i };
function Ti(e) {
    var t = e.state,
        r = e.name;
    t.modifiersData[r] = vr({
        reference: t.rects.reference,
        element: t.rects.popper,
        strategy: "absolute",
        placement: t.placement,
    });
}
const xi = { name: "popperOffsets", enabled: !0, phase: "read", fn: Ti, data: {} };
function Oi(e) {
    return e === "x" ? "y" : "x";
}
function qi(e) {
    var t = e.state,
        r = e.options,
        i = e.name,
        n = r.mainAxis,
        o = n === void 0 ? !0 : n,
        a = r.altAxis,
        s = a === void 0 ? !1 : a,
        l = r.boundary,
        u = r.rootBoundary,
        d = r.altBoundary,
        p = r.padding,
        y = r.tether,
        m = y === void 0 ? !0 : y,
        b = r.tetherOffset,
        S = b === void 0 ? 0 : b,
        w = Fe(t, { boundary: l, rootBoundary: u, padding: p, altBoundary: d }),
        h = ee(t.placement),
        E = qe(t.placement),
        _ = !E,
        c = kt(h),
        g = Oi(c),
        v = t.modifiersData.popperOffsets,
        T = t.rects.reference,
        R = t.rects.popper,
        k = typeof S == "function" ? S(Object.assign({}, t.rects, { placement: t.placement })) : S,
        C = typeof k == "number" ? { mainAxis: k, altAxis: k } : Object.assign({ mainAxis: 0, altAxis: 0 }, k),
        M = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null,
        O = { x: 0, y: 0 };
    if (v) {
        if (o) {
            var D,
                N = c === "y" ? j : z,
                P = c === "y" ? X : G,
                $ = c === "y" ? "height" : "width",
                I = v[c],
                H = I + w[N],
                W = I - w[P],
                F = m ? -R[$] / 2 : 0,
                de = E === Te ? T[$] : R[$],
                Q = E === Te ? -R[$] : -T[$],
                fe = t.elements.arrow,
                re = m && fe ? Mt(fe) : { width: 0, height: 0 },
                K = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : dr(),
                ie = K[N],
                we = K[P],
                ne = Ie(0, T[$], re[$]),
                be = _ ? T[$] / 2 - F - ne - ie - C.mainAxis : de - ne - ie - C.mainAxis,
                ae = _ ? -T[$] / 2 + F + ne + we + C.mainAxis : Q + ne + we + C.mainAxis,
                Se = t.elements.arrow && ze(t.elements.arrow),
                Ue = Se ? (c === "y" ? Se.clientTop || 0 : Se.clientLeft || 0) : 0,
                Me = (D = M == null ? void 0 : M[c]) != null ? D : 0,
                Ve = I + be - Me - Ue,
                Ye = I + ae - Me,
                ke = Ie(m ? lt(H, Ve) : H, I, m ? ge(W, Ye) : W);
            (v[c] = ke), (O[c] = ke - I);
        }
        if (s) {
            var De,
                Xe = c === "x" ? j : z,
                Ge = c === "x" ? X : G,
                oe = v[g],
                le = g === "y" ? "height" : "width",
                Re = oe + w[Xe],
                pe = oe - w[Ge],
                Pe = [j, z].indexOf(h) !== -1,
                Ke = (De = M == null ? void 0 : M[g]) != null ? De : 0,
                Je = Pe ? Re : oe - T[le] - R[le] - Ke + C.altAxis,
                Qe = Pe ? oe + T[le] + R[le] - Ke - C.altAxis : pe,
                Ze = m && Pe ? Zr(Je, oe, Qe) : Ie(m ? Je : Re, oe, m ? Qe : pe);
            (v[g] = Ze), (O[g] = Ze - oe);
        }
        t.modifiersData[i] = O;
    }
}
const Ci = { name: "preventOverflow", enabled: !0, phase: "main", fn: qi, requiresIfExists: ["offset"] };
function Mi(e) {
    return { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop };
}
function ki(e) {
    return e === U(e) || !Y(e) ? Dt(e) : Mi(e);
}
function Di(e) {
    var t = e.getBoundingClientRect(),
        r = xe(t.width) / e.offsetWidth || 1,
        i = xe(t.height) / e.offsetHeight || 1;
    return r !== 1 || i !== 1;
}
function Ri(e, t, r) {
    r === void 0 && (r = !1);
    var i = Y(t),
        n = Y(t) && Di(t),
        o = ue(t),
        a = Oe(e, n, r),
        s = { scrollLeft: 0, scrollTop: 0 },
        l = { x: 0, y: 0 };
    return (
        (i || (!i && !r)) &&
            ((te(t) !== "body" || Pt(o)) && (s = ki(t)),
            Y(t) ? ((l = Oe(t, !0)), (l.x += t.clientLeft), (l.y += t.clientTop)) : o && (l.x = Rt(o))),
        { x: a.left + s.scrollLeft - l.x, y: a.top + s.scrollTop - l.y, width: a.width, height: a.height }
    );
}
function Pi(e) {
    var t = new Map(),
        r = new Set(),
        i = [];
    e.forEach(function (o) {
        t.set(o.name, o);
    });
    function n(o) {
        r.add(o.name);
        var a = [].concat(o.requires || [], o.requiresIfExists || []);
        a.forEach(function (s) {
            if (!r.has(s)) {
                var l = t.get(s);
                l && n(l);
            }
        }),
            i.push(o);
    }
    return (
        e.forEach(function (o) {
            r.has(o.name) || n(o);
        }),
        i
    );
}
function Hi(e) {
    var t = Pi(e);
    return Xr.reduce(function (r, i) {
        return r.concat(
            t.filter(function (n) {
                return n.phase === i;
            })
        );
    }, []);
}
function $i(e) {
    var t;
    return function () {
        return (
            t ||
                (t = new Promise(function (r) {
                    Promise.resolve().then(function () {
                        (t = void 0), r(e());
                    });
                })),
            t
        );
    };
}
function Ii(e) {
    var t = e.reduce(function (r, i) {
        var n = r[i.name];
        return (
            (r[i.name] = n
                ? Object.assign({}, n, i, {
                      options: Object.assign({}, n.options, i.options),
                      data: Object.assign({}, n.data, i.data),
                  })
                : i),
            r
        );
    }, {});
    return Object.keys(t).map(function (r) {
        return t[r];
    });
}
var Yt = { placement: "bottom", modifiers: [], strategy: "absolute" };
function Xt() {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
    return !t.some(function (i) {
        return !(i && typeof i.getBoundingClientRect == "function");
    });
}
function Ni(e) {
    e === void 0 && (e = {});
    var t = e,
        r = t.defaultModifiers,
        i = r === void 0 ? [] : r,
        n = t.defaultOptions,
        o = n === void 0 ? Yt : n;
    return function (s, l, u) {
        u === void 0 && (u = o);
        var d = {
                placement: "bottom",
                orderedModifiers: [],
                options: Object.assign({}, Yt, o),
                modifiersData: {},
                elements: { reference: s, popper: l },
                attributes: {},
                styles: {},
            },
            p = [],
            y = !1,
            m = {
                state: d,
                setOptions: function (h) {
                    var E = typeof h == "function" ? h(d.options) : h;
                    S(),
                        (d.options = Object.assign({}, o, d.options, E)),
                        (d.scrollParents = {
                            reference: ye(s) ? Ne(s) : s.contextElement ? Ne(s.contextElement) : [],
                            popper: Ne(l),
                        });
                    var _ = Hi(Ii([].concat(i, d.options.modifiers)));
                    return (
                        (d.orderedModifiers = _.filter(function (c) {
                            return c.enabled;
                        })),
                        b(),
                        m.update()
                    );
                },
                forceUpdate: function () {
                    if (!y) {
                        var h = d.elements,
                            E = h.reference,
                            _ = h.popper;
                        if (Xt(E, _)) {
                            (d.rects = { reference: Ri(E, ze(_), d.options.strategy === "fixed"), popper: Mt(_) }),
                                (d.reset = !1),
                                (d.placement = d.options.placement),
                                d.orderedModifiers.forEach(function (C) {
                                    return (d.modifiersData[C.name] = Object.assign({}, C.data));
                                });
                            for (var c = 0; c < d.orderedModifiers.length; c++) {
                                if (d.reset === !0) {
                                    (d.reset = !1), (c = -1);
                                    continue;
                                }
                                var g = d.orderedModifiers[c],
                                    v = g.fn,
                                    T = g.options,
                                    R = T === void 0 ? {} : T,
                                    k = g.name;
                                typeof v == "function" && (d = v({ state: d, options: R, name: k, instance: m }) || d);
                            }
                        }
                    }
                },
                update: $i(function () {
                    return new Promise(function (w) {
                        m.forceUpdate(), w(d);
                    });
                }),
                destroy: function () {
                    S(), (y = !0);
                },
            };
        if (!Xt(s, l)) return m;
        m.setOptions(u).then(function (w) {
            !y && u.onFirstUpdate && u.onFirstUpdate(w);
        });
        function b() {
            d.orderedModifiers.forEach(function (w) {
                var h = w.name,
                    E = w.options,
                    _ = E === void 0 ? {} : E,
                    c = w.effect;
                if (typeof c == "function") {
                    var g = c({ state: d, name: h, instance: m, options: _ }),
                        v = function () {};
                    p.push(g || v);
                }
            });
        }
        function S() {
            p.forEach(function (w) {
                return w();
            }),
                (p = []);
        }
        return m;
    };
}
var Bi = [ci, xi, ai, lr, Ai, bi, Ci, ii, Li],
    Wi = Ni({ defaultModifiers: Bi }),
    Fi = "tippy-box",
    mr = "tippy-content",
    ji = "tippy-backdrop",
    gr = "tippy-arrow",
    yr = "tippy-svg-arrow",
    me = { passive: !0, capture: !0 },
    wr = function () {
        return document.body;
    };
function gt(e, t, r) {
    if (Array.isArray(e)) {
        var i = e[t];
        return i ?? (Array.isArray(r) ? r[t] : r);
    }
    return e;
}
function Ht(e, t) {
    var r = {}.toString.call(e);
    return r.indexOf("[object") === 0 && r.indexOf(t + "]") > -1;
}
function br(e, t) {
    return typeof e == "function" ? e.apply(void 0, t) : e;
}
function Gt(e, t) {
    if (t === 0) return e;
    var r;
    return function (i) {
        clearTimeout(r),
            (r = setTimeout(function () {
                e(i);
            }, t));
    };
}
function zi(e) {
    return e.split(/\s+/).filter(Boolean);
}
function _e(e) {
    return [].concat(e);
}
function Kt(e, t) {
    e.indexOf(t) === -1 && e.push(t);
}
function Ui(e) {
    return e.filter(function (t, r) {
        return e.indexOf(t) === r;
    });
}
function Vi(e) {
    return e.split("-")[0];
}
function ct(e) {
    return [].slice.call(e);
}
function Jt(e) {
    return Object.keys(e).reduce(function (t, r) {
        return e[r] !== void 0 && (t[r] = e[r]), t;
    }, {});
}
function Be() {
    return document.createElement("div");
}
function dt(e) {
    return ["Element", "Fragment"].some(function (t) {
        return Ht(e, t);
    });
}
function Yi(e) {
    return Ht(e, "NodeList");
}
function Xi(e) {
    return Ht(e, "MouseEvent");
}
function Gi(e) {
    return !!(e && e._tippy && e._tippy.reference === e);
}
function Ki(e) {
    return dt(e) ? [e] : Yi(e) ? ct(e) : Array.isArray(e) ? e : ct(document.querySelectorAll(e));
}
function yt(e, t) {
    e.forEach(function (r) {
        r && (r.style.transitionDuration = t + "ms");
    });
}
function Qt(e, t) {
    e.forEach(function (r) {
        r && r.setAttribute("data-state", t);
    });
}
function Ji(e) {
    var t,
        r = _e(e),
        i = r[0];
    return i != null && (t = i.ownerDocument) != null && t.body ? i.ownerDocument : document;
}
function Qi(e, t) {
    var r = t.clientX,
        i = t.clientY;
    return e.every(function (n) {
        var o = n.popperRect,
            a = n.popperState,
            s = n.props,
            l = s.interactiveBorder,
            u = Vi(a.placement),
            d = a.modifiersData.offset;
        if (!d) return !0;
        var p = u === "bottom" ? d.top.y : 0,
            y = u === "top" ? d.bottom.y : 0,
            m = u === "right" ? d.left.x : 0,
            b = u === "left" ? d.right.x : 0,
            S = o.top - i + p > l,
            w = i - o.bottom - y > l,
            h = o.left - r + m > l,
            E = r - o.right - b > l;
        return S || w || h || E;
    });
}
function wt(e, t, r) {
    var i = t + "EventListener";
    ["transitionend", "webkitTransitionEnd"].forEach(function (n) {
        e[i](n, r);
    });
}
function Zt(e, t) {
    for (var r = t; r; ) {
        var i;
        if (e.contains(r)) return !0;
        r = r.getRootNode == null || (i = r.getRootNode()) == null ? void 0 : i.host;
    }
    return !1;
}
var Z = { isTouch: !1 },
    er = 0;
function Zi() {
    Z.isTouch || ((Z.isTouch = !0), window.performance && document.addEventListener("mousemove", Sr));
}
function Sr() {
    var e = performance.now();
    e - er < 20 && ((Z.isTouch = !1), document.removeEventListener("mousemove", Sr)), (er = e);
}
function en() {
    var e = document.activeElement;
    if (Gi(e)) {
        var t = e._tippy;
        e.blur && !t.state.isVisible && e.blur();
    }
}
function tn() {
    document.addEventListener("touchstart", Zi, me), window.addEventListener("blur", en);
}
var rn = typeof window < "u" && typeof document < "u",
    nn = rn ? !!window.msCrypto : !1,
    on = { animateFill: !1, followCursor: !1, inlinePositioning: !1, sticky: !1 },
    sn = {
        allowHTML: !1,
        animation: "fade",
        arrow: !0,
        content: "",
        inertia: !1,
        maxWidth: 350,
        role: "tooltip",
        theme: "",
        zIndex: 9999,
    },
    J = Object.assign(
        {
            appendTo: wr,
            aria: { content: "auto", expanded: "auto" },
            delay: 0,
            duration: [300, 250],
            getReferenceClientRect: null,
            hideOnClick: !0,
            ignoreAttributes: !1,
            interactive: !1,
            interactiveBorder: 2,
            interactiveDebounce: 0,
            moveTransition: "",
            offset: [0, 10],
            onAfterUpdate: function () {},
            onBeforeUpdate: function () {},
            onCreate: function () {},
            onDestroy: function () {},
            onHidden: function () {},
            onHide: function () {},
            onMount: function () {},
            onShow: function () {},
            onShown: function () {},
            onTrigger: function () {},
            onUntrigger: function () {},
            onClickOutside: function () {},
            placement: "top",
            plugins: [],
            popperOptions: {},
            render: null,
            showOnCreate: !1,
            touch: !0,
            trigger: "mouseenter focus",
            triggerTarget: null,
        },
        on,
        sn
    ),
    an = Object.keys(J),
    ln = function (t) {
        var r = Object.keys(t);
        r.forEach(function (i) {
            J[i] = t[i];
        });
    };
function Lr(e) {
    var t = e.plugins || [],
        r = t.reduce(function (i, n) {
            var o = n.name,
                a = n.defaultValue;
            if (o) {
                var s;
                i[o] = e[o] !== void 0 ? e[o] : (s = J[o]) != null ? s : a;
            }
            return i;
        }, {});
    return Object.assign({}, e, r);
}
function cn(e, t) {
    var r = t ? Object.keys(Lr(Object.assign({}, J, { plugins: t }))) : an,
        i = r.reduce(function (n, o) {
            var a = (e.getAttribute("data-tippy-" + o) || "").trim();
            if (!a) return n;
            if (o === "content") n[o] = a;
            else
                try {
                    n[o] = JSON.parse(a);
                } catch {
                    n[o] = a;
                }
            return n;
        }, {});
    return i;
}
function tr(e, t) {
    var r = Object.assign({}, t, { content: br(t.content, [e]) }, t.ignoreAttributes ? {} : cn(e, t.plugins));
    return (
        (r.aria = Object.assign({}, J.aria, r.aria)),
        (r.aria = {
            expanded: r.aria.expanded === "auto" ? t.interactive : r.aria.expanded,
            content: r.aria.content === "auto" ? (t.interactive ? null : "describedby") : r.aria.content,
        }),
        r
    );
}
var un = function () {
    return "innerHTML";
};
function Tt(e, t) {
    e[un()] = t;
}
function rr(e) {
    var t = Be();
    return e === !0 ? (t.className = gr) : ((t.className = yr), dt(e) ? t.appendChild(e) : Tt(t, e)), t;
}
function ir(e, t) {
    dt(t.content)
        ? (Tt(e, ""), e.appendChild(t.content))
        : typeof t.content != "function" && (t.allowHTML ? Tt(e, t.content) : (e.textContent = t.content));
}
function xt(e) {
    var t = e.firstElementChild,
        r = ct(t.children);
    return {
        box: t,
        content: r.find(function (i) {
            return i.classList.contains(mr);
        }),
        arrow: r.find(function (i) {
            return i.classList.contains(gr) || i.classList.contains(yr);
        }),
        backdrop: r.find(function (i) {
            return i.classList.contains(ji);
        }),
    };
}
function Er(e) {
    var t = Be(),
        r = Be();
    (r.className = Fi), r.setAttribute("data-state", "hidden"), r.setAttribute("tabindex", "-1");
    var i = Be();
    (i.className = mr),
        i.setAttribute("data-state", "hidden"),
        ir(i, e.props),
        t.appendChild(r),
        r.appendChild(i),
        n(e.props, e.props);
    function n(o, a) {
        var s = xt(t),
            l = s.box,
            u = s.content,
            d = s.arrow;
        a.theme ? l.setAttribute("data-theme", a.theme) : l.removeAttribute("data-theme"),
            typeof a.animation == "string"
                ? l.setAttribute("data-animation", a.animation)
                : l.removeAttribute("data-animation"),
            a.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"),
            (l.style.maxWidth = typeof a.maxWidth == "number" ? a.maxWidth + "px" : a.maxWidth),
            a.role ? l.setAttribute("role", a.role) : l.removeAttribute("role"),
            (o.content !== a.content || o.allowHTML !== a.allowHTML) && ir(u, e.props),
            a.arrow
                ? d
                    ? o.arrow !== a.arrow && (l.removeChild(d), l.appendChild(rr(a.arrow)))
                    : l.appendChild(rr(a.arrow))
                : d && l.removeChild(d);
    }
    return { popper: t, onUpdate: n };
}
Er.$$tippy = !0;
var dn = 1,
    nt = [],
    bt = [];
function fn(e, t) {
    var r = tr(e, Object.assign({}, J, Lr(Jt(t)))),
        i,
        n,
        o,
        a = !1,
        s = !1,
        l = !1,
        u = !1,
        d,
        p,
        y,
        m = [],
        b = Gt(Ve, r.interactiveDebounce),
        S,
        w = dn++,
        h = null,
        E = Ui(r.plugins),
        _ = { isEnabled: !0, isVisible: !1, isDestroyed: !1, isMounted: !1, isShown: !1 },
        c = {
            id: w,
            reference: e,
            popper: Be(),
            popperInstance: h,
            props: r,
            state: _,
            plugins: E,
            clearDelayTimeouts: Je,
            setProps: Qe,
            setContent: Ze,
            show: _r,
            hide: Ar,
            hideWithInteractivity: Tr,
            enable: Pe,
            disable: Ke,
            unmount: xr,
            destroy: Or,
        };
    if (!r.render) return c;
    var g = r.render(c),
        v = g.popper,
        T = g.onUpdate;
    v.setAttribute("data-tippy-root", ""), (v.id = "tippy-" + c.id), (c.popper = v), (e._tippy = c), (v._tippy = c);
    var R = E.map(function (f) {
            return f.fn(c);
        }),
        k = e.hasAttribute("aria-expanded");
    return (
        Se(),
        F(),
        I(),
        H("onCreate", [c]),
        r.showOnCreate && Re(),
        v.addEventListener("mouseenter", function () {
            c.props.interactive && c.state.isVisible && c.clearDelayTimeouts();
        }),
        v.addEventListener("mouseleave", function () {
            c.props.interactive && c.props.trigger.indexOf("mouseenter") >= 0 && N().addEventListener("mousemove", b);
        }),
        c
    );
    function C() {
        var f = c.props.touch;
        return Array.isArray(f) ? f : [f, 0];
    }
    function M() {
        return C()[0] === "hold";
    }
    function O() {
        var f;
        return !!((f = c.props.render) != null && f.$$tippy);
    }
    function D() {
        return S || e;
    }
    function N() {
        var f = D().parentNode;
        return f ? Ji(f) : document;
    }
    function P() {
        return xt(v);
    }
    function $(f) {
        return (c.state.isMounted && !c.state.isVisible) || Z.isTouch || (d && d.type === "focus")
            ? 0
            : gt(c.props.delay, f ? 0 : 1, J.delay);
    }
    function I(f) {
        f === void 0 && (f = !1),
            (v.style.pointerEvents = c.props.interactive && !f ? "" : "none"),
            (v.style.zIndex = "" + c.props.zIndex);
    }
    function H(f, L, A) {
        if (
            (A === void 0 && (A = !0),
            R.forEach(function (x) {
                x[f] && x[f].apply(x, L);
            }),
            A)
        ) {
            var q;
            (q = c.props)[f].apply(q, L);
        }
    }
    function W() {
        var f = c.props.aria;
        if (f.content) {
            var L = "aria-" + f.content,
                A = v.id,
                q = _e(c.props.triggerTarget || e);
            q.forEach(function (x) {
                var B = x.getAttribute(L);
                if (c.state.isVisible) x.setAttribute(L, B ? B + " " + A : A);
                else {
                    var V = B && B.replace(A, "").trim();
                    V ? x.setAttribute(L, V) : x.removeAttribute(L);
                }
            });
        }
    }
    function F() {
        if (!(k || !c.props.aria.expanded)) {
            var f = _e(c.props.triggerTarget || e);
            f.forEach(function (L) {
                c.props.interactive
                    ? L.setAttribute("aria-expanded", c.state.isVisible && L === D() ? "true" : "false")
                    : L.removeAttribute("aria-expanded");
            });
        }
    }
    function de() {
        N().removeEventListener("mousemove", b),
            (nt = nt.filter(function (f) {
                return f !== b;
            }));
    }
    function Q(f) {
        if (!(Z.isTouch && (l || f.type === "mousedown"))) {
            var L = (f.composedPath && f.composedPath()[0]) || f.target;
            if (!(c.props.interactive && Zt(v, L))) {
                if (
                    _e(c.props.triggerTarget || e).some(function (A) {
                        return Zt(A, L);
                    })
                ) {
                    if (Z.isTouch || (c.state.isVisible && c.props.trigger.indexOf("click") >= 0)) return;
                } else H("onClickOutside", [c, f]);
                c.props.hideOnClick === !0 &&
                    (c.clearDelayTimeouts(),
                    c.hide(),
                    (s = !0),
                    setTimeout(function () {
                        s = !1;
                    }),
                    c.state.isMounted || ie());
            }
        }
    }
    function fe() {
        l = !0;
    }
    function re() {
        l = !1;
    }
    function K() {
        var f = N();
        f.addEventListener("mousedown", Q, !0),
            f.addEventListener("touchend", Q, me),
            f.addEventListener("touchstart", re, me),
            f.addEventListener("touchmove", fe, me);
    }
    function ie() {
        var f = N();
        f.removeEventListener("mousedown", Q, !0),
            f.removeEventListener("touchend", Q, me),
            f.removeEventListener("touchstart", re, me),
            f.removeEventListener("touchmove", fe, me);
    }
    function we(f, L) {
        be(f, function () {
            !c.state.isVisible && v.parentNode && v.parentNode.contains(v) && L();
        });
    }
    function ne(f, L) {
        be(f, L);
    }
    function be(f, L) {
        var A = P().box;
        function q(x) {
            x.target === A && (wt(A, "remove", q), L());
        }
        if (f === 0) return L();
        wt(A, "remove", p), wt(A, "add", q), (p = q);
    }
    function ae(f, L, A) {
        A === void 0 && (A = !1);
        var q = _e(c.props.triggerTarget || e);
        q.forEach(function (x) {
            x.addEventListener(f, L, A), m.push({ node: x, eventType: f, handler: L, options: A });
        });
    }
    function Se() {
        M() && (ae("touchstart", Me, { passive: !0 }), ae("touchend", Ye, { passive: !0 })),
            zi(c.props.trigger).forEach(function (f) {
                if (f !== "manual")
                    switch ((ae(f, Me), f)) {
                        case "mouseenter":
                            ae("mouseleave", Ye);
                            break;
                        case "focus":
                            ae(nn ? "focusout" : "blur", ke);
                            break;
                        case "focusin":
                            ae("focusout", ke);
                            break;
                    }
            });
    }
    function Ue() {
        m.forEach(function (f) {
            var L = f.node,
                A = f.eventType,
                q = f.handler,
                x = f.options;
            L.removeEventListener(A, q, x);
        }),
            (m = []);
    }
    function Me(f) {
        var L,
            A = !1;
        if (!(!c.state.isEnabled || De(f) || s)) {
            var q = ((L = d) == null ? void 0 : L.type) === "focus";
            (d = f),
                (S = f.currentTarget),
                F(),
                !c.state.isVisible &&
                    Xi(f) &&
                    nt.forEach(function (x) {
                        return x(f);
                    }),
                f.type === "click" &&
                (c.props.trigger.indexOf("mouseenter") < 0 || a) &&
                c.props.hideOnClick !== !1 &&
                c.state.isVisible
                    ? (A = !0)
                    : Re(f),
                f.type === "click" && (a = !A),
                A && !q && pe(f);
        }
    }
    function Ve(f) {
        var L = f.target,
            A = D().contains(L) || v.contains(L);
        if (!(f.type === "mousemove" && A)) {
            var q = le()
                .concat(v)
                .map(function (x) {
                    var B,
                        V = x._tippy,
                        Le = (B = V.popperInstance) == null ? void 0 : B.state;
                    return Le ? { popperRect: x.getBoundingClientRect(), popperState: Le, props: r } : null;
                })
                .filter(Boolean);
            Qi(q, f) && (de(), pe(f));
        }
    }
    function Ye(f) {
        var L = De(f) || (c.props.trigger.indexOf("click") >= 0 && a);
        if (!L) {
            if (c.props.interactive) {
                c.hideWithInteractivity(f);
                return;
            }
            pe(f);
        }
    }
    function ke(f) {
        (c.props.trigger.indexOf("focusin") < 0 && f.target !== D()) ||
            (c.props.interactive && f.relatedTarget && v.contains(f.relatedTarget)) ||
            pe(f);
    }
    function De(f) {
        return Z.isTouch ? M() !== f.type.indexOf("touch") >= 0 : !1;
    }
    function Xe() {
        Ge();
        var f = c.props,
            L = f.popperOptions,
            A = f.placement,
            q = f.offset,
            x = f.getReferenceClientRect,
            B = f.moveTransition,
            V = O() ? xt(v).arrow : null,
            Le = x ? { getBoundingClientRect: x, contextElement: x.contextElement || D() } : e,
            $t = {
                name: "$$tippy",
                enabled: !0,
                phase: "beforeWrite",
                requires: ["computeStyles"],
                fn: function (et) {
                    var Ee = et.state;
                    if (O()) {
                        var qr = P(),
                            pt = qr.box;
                        ["placement", "reference-hidden", "escaped"].forEach(function (tt) {
                            tt === "placement"
                                ? pt.setAttribute("data-placement", Ee.placement)
                                : Ee.attributes.popper["data-popper-" + tt]
                                  ? pt.setAttribute("data-" + tt, "")
                                  : pt.removeAttribute("data-" + tt);
                        }),
                            (Ee.attributes.popper = {});
                    }
                },
            },
            he = [
                { name: "offset", options: { offset: q } },
                { name: "preventOverflow", options: { padding: { top: 2, bottom: 2, left: 5, right: 5 } } },
                { name: "flip", options: { padding: 5 } },
                { name: "computeStyles", options: { adaptive: !B } },
                $t,
            ];
        O() && V && he.push({ name: "arrow", options: { element: V, padding: 3 } }),
            he.push.apply(he, (L == null ? void 0 : L.modifiers) || []),
            (c.popperInstance = Wi(Le, v, Object.assign({}, L, { placement: A, onFirstUpdate: y, modifiers: he })));
    }
    function Ge() {
        c.popperInstance && (c.popperInstance.destroy(), (c.popperInstance = null));
    }
    function oe() {
        var f = c.props.appendTo,
            L,
            A = D();
        (c.props.interactive && f === wr) || f === "parent" ? (L = A.parentNode) : (L = br(f, [A])),
            L.contains(v) || L.appendChild(v),
            (c.state.isMounted = !0),
            Xe();
    }
    function le() {
        return ct(v.querySelectorAll("[data-tippy-root]"));
    }
    function Re(f) {
        c.clearDelayTimeouts(), f && H("onTrigger", [c, f]), K();
        var L = $(!0),
            A = C(),
            q = A[0],
            x = A[1];
        Z.isTouch && q === "hold" && x && (L = x),
            L
                ? (i = setTimeout(function () {
                      c.show();
                  }, L))
                : c.show();
    }
    function pe(f) {
        if ((c.clearDelayTimeouts(), H("onUntrigger", [c, f]), !c.state.isVisible)) {
            ie();
            return;
        }
        if (
            !(
                c.props.trigger.indexOf("mouseenter") >= 0 &&
                c.props.trigger.indexOf("click") >= 0 &&
                ["mouseleave", "mousemove"].indexOf(f.type) >= 0 &&
                a
            )
        ) {
            var L = $(!1);
            L
                ? (n = setTimeout(function () {
                      c.state.isVisible && c.hide();
                  }, L))
                : (o = requestAnimationFrame(function () {
                      c.hide();
                  }));
        }
    }
    function Pe() {
        c.state.isEnabled = !0;
    }
    function Ke() {
        c.hide(), (c.state.isEnabled = !1);
    }
    function Je() {
        clearTimeout(i), clearTimeout(n), cancelAnimationFrame(o);
    }
    function Qe(f) {
        if (!c.state.isDestroyed) {
            H("onBeforeUpdate", [c, f]), Ue();
            var L = c.props,
                A = tr(e, Object.assign({}, L, Jt(f), { ignoreAttributes: !0 }));
            (c.props = A),
                Se(),
                L.interactiveDebounce !== A.interactiveDebounce && (de(), (b = Gt(Ve, A.interactiveDebounce))),
                L.triggerTarget && !A.triggerTarget
                    ? _e(L.triggerTarget).forEach(function (q) {
                          q.removeAttribute("aria-expanded");
                      })
                    : A.triggerTarget && e.removeAttribute("aria-expanded"),
                F(),
                I(),
                T && T(L, A),
                c.popperInstance &&
                    (Xe(),
                    le().forEach(function (q) {
                        requestAnimationFrame(q._tippy.popperInstance.forceUpdate);
                    })),
                H("onAfterUpdate", [c, f]);
        }
    }
    function Ze(f) {
        c.setProps({ content: f });
    }
    function _r() {
        var f = c.state.isVisible,
            L = c.state.isDestroyed,
            A = !c.state.isEnabled,
            q = Z.isTouch && !c.props.touch,
            x = gt(c.props.duration, 0, J.duration);
        if (!(f || L || A || q) && !D().hasAttribute("disabled") && (H("onShow", [c], !1), c.props.onShow(c) !== !1)) {
            if (
                ((c.state.isVisible = !0),
                O() && (v.style.visibility = "visible"),
                I(),
                K(),
                c.state.isMounted || (v.style.transition = "none"),
                O())
            ) {
                var B = P(),
                    V = B.box,
                    Le = B.content;
                yt([V, Le], 0);
            }
            (y = function () {
                var he;
                if (!(!c.state.isVisible || u)) {
                    if (
                        ((u = !0),
                        v.offsetHeight,
                        (v.style.transition = c.props.moveTransition),
                        O() && c.props.animation)
                    ) {
                        var ft = P(),
                            et = ft.box,
                            Ee = ft.content;
                        yt([et, Ee], x), Qt([et, Ee], "visible");
                    }
                    W(),
                        F(),
                        Kt(bt, c),
                        (he = c.popperInstance) == null || he.forceUpdate(),
                        H("onMount", [c]),
                        c.props.animation &&
                            O() &&
                            ne(x, function () {
                                (c.state.isShown = !0), H("onShown", [c]);
                            });
                }
            }),
                oe();
        }
    }
    function Ar() {
        var f = !c.state.isVisible,
            L = c.state.isDestroyed,
            A = !c.state.isEnabled,
            q = gt(c.props.duration, 1, J.duration);
        if (!(f || L || A) && (H("onHide", [c], !1), c.props.onHide(c) !== !1)) {
            if (
                ((c.state.isVisible = !1),
                (c.state.isShown = !1),
                (u = !1),
                (a = !1),
                O() && (v.style.visibility = "hidden"),
                de(),
                ie(),
                I(!0),
                O())
            ) {
                var x = P(),
                    B = x.box,
                    V = x.content;
                c.props.animation && (yt([B, V], q), Qt([B, V], "hidden"));
            }
            W(), F(), c.props.animation ? O() && we(q, c.unmount) : c.unmount();
        }
    }
    function Tr(f) {
        N().addEventListener("mousemove", b), Kt(nt, b), b(f);
    }
    function xr() {
        c.state.isVisible && c.hide(),
            c.state.isMounted &&
                (Ge(),
                le().forEach(function (f) {
                    f._tippy.unmount();
                }),
                v.parentNode && v.parentNode.removeChild(v),
                (bt = bt.filter(function (f) {
                    return f !== c;
                })),
                (c.state.isMounted = !1),
                H("onHidden", [c]));
    }
    function Or() {
        c.state.isDestroyed ||
            (c.clearDelayTimeouts(),
            c.unmount(),
            Ue(),
            delete e._tippy,
            (c.state.isDestroyed = !0),
            H("onDestroy", [c]));
    }
}
function Ce(e, t) {
    t === void 0 && (t = {});
    var r = J.plugins.concat(t.plugins || []);
    tn();
    var i = Object.assign({}, t, { plugins: r }),
        n = Ki(e),
        o = n.reduce(function (a, s) {
            var l = s && fn(s, i);
            return l && a.push(l), a;
        }, []);
    return dt(e) ? o[0] : o;
}
Ce.defaultProps = J;
Ce.setDefaultProps = ln;
Ce.currentInput = Z;
Object.assign({}, lr, {
    effect: function (t) {
        var r = t.state,
            i = {
                popper: { position: r.options.strategy, left: "0", top: "0", margin: "0" },
                arrow: { position: "absolute" },
                reference: {},
            };
        Object.assign(r.elements.popper.style, i.popper),
            (r.styles = i),
            r.elements.arrow && Object.assign(r.elements.arrow.style, i.arrow);
    },
});
Ce.setDefaultProps({ render: Er });
const pn = () => {
        function e({ localStorageTheme: s, systemSettingDark: l }) {
            return s !== null ? s : l.matches ? "dark" : "light";
        }
        function t({ buttonEl: s, isDark: l }) {
            const u = l ? "Change to light theme" : "Change to dark theme";
            s.setAttribute("aria-label", u), s.setAttribute("title", u);
            const d = document.querySelectorAll("[data-theme-label]");
            d.length > 0 &&
                d.forEach((p) => {
                    p.textContent = l ? "Dark mode" : "Light mode";
                });
        }
        function r({ theme: s }) {
            var l;
            (l = document.querySelector("html")) == null || l.setAttribute("data-theme", s);
        }
        const i = document.querySelectorAll("[data-theme-toggle]");
        if (i.length === 0) return;
        const n = localStorage.getItem("theme"),
            o = window.matchMedia("(prefers-color-scheme: dark)");
        let a = e({ localStorageTheme: n, systemSettingDark: o });
        r({ theme: a }),
            i.forEach((s) => {
                t({ buttonEl: s, isDark: a === "dark" }),
                    s.addEventListener("click", (l) => {
                        const u = a === "dark" ? "light" : "dark";
                        localStorage.setItem("theme", u),
                            i.forEach((d) => {
                                t({ buttonEl: d, isDark: u === "dark" });
                            }),
                            r({ theme: u }),
                            (a = u);
                    });
            });
    };
function mn(e) {
    const t = `/products/${e}`;
    fetch(t)
        .then((r) => r.text())
        .then((r) => {
            const n = new DOMParser().parseFromString(r, "text/html"),
                o = n.querySelector(".product__info .price").innerHTML,
                a = JSON.parse(localStorage.getItem("wishlist")) || [],
                s = a.find((p) => p.handle === e),
                l = n.querySelector(".product__info .badges");
            s &&
                ((s.price = o),
                (s.last_updated_price = Date.now()),
                (s.tags = l ? l.innerHTML : ""),
                (s.on_sale = n.querySelector(".product__info .price").classList.contains("price--on-sale")),
                localStorage.setItem("wishlist", JSON.stringify(a)));
            const d = document.querySelector("#wishlist .wishlist-list").querySelector(`[data-handle="${e}"]`);
            d &&
                ((d.querySelector(".price").innerHTML = o),
                (d.querySelector(".badges").innerHTML = l ? l.innerHTML : ""),
                s.on_sale
                    ? d.querySelector(".price").classList.add("price--on-sale")
                    : d.querySelector(".price").classList.remove("price--on-sale"));
        });
}
const Lt = (e) => {
        const t = document.querySelector("#wishlist-count");
        t &&
            ((t.querySelector("span").innerHTML = e), e > 0 ? t.classList.remove("hidden") : t.classList.add("hidden"));
    },
    gn = () => {
        const e = JSON.parse(localStorage.getItem("wishlist")) || [],
            t = document.querySelector("#wishlist .wishlist-list");
        if ((Lt(e.length), t))
            if (e.length === 0) t.innerHTML = St;
            else {
                const n = e
                    .map((o) =>
                        o.image
                            ? ((window.location.hash.indexOf("update") !== !1 ||
                                  !o.last_updated_price ||
                                  Date.now() - o.last_updated_price > 864e5) &&
                                  mn(o.handle),
                              `
            <li class="product-grid__item" data-handle="${o.handle}">
            <div class="card-wrapper product-card-wrapper">
              <div class="badges">${o.tags || ""}</div>
              <div class="card card--media">
                <div class="wishlist-item__content">
                  <div class="card__inner">
                    <a href="/products/${o.handle}" class="wishlist-item__image">
                      <div class="card__media">
                        <img src="${o.image}" alt="${o.title}" loading="lazy" width="430" height="430" />
                      </div>
                    </a>

                    <div class="card__content">
                      <a href="/products/${o.handle}" class="card__information">
                        <p class="body-md card__artist">${o.title}</p>

                        <h3 class="card__heading heading-md">${o.description || ""}</h3>

                        <div class="price ${o.on_sale === !0 ? "price--on-sale" : ""}">${o.price || ""}</div>
                      </a>

                      <button
                        class="card__wishlist wishlist-trigger"
                        data-product-handle="${o.handle}"
                        data-product-image="${o.image}"
                        data-product-title="${o.title}"
                        data-product-description="${o.description}"
                      >
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1"
                        stroke-linecap="square"
                        aria-hidden="true"
                        stroke-linejoin="round"
                      >
                        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                      </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          `)
                            : null
                    )
                    .filter((o) => o !== null)
                    .join("");
                n ? (t.innerHTML = n) : (t.innerHTML = St);
            }
        const r = (n) => {
            const o = n.classList.contains("wishlist-trigger--active"),
                a = n.getAttribute("data-product-handle");
            if (o) {
                n.classList.remove("wishlist-trigger--active");
                const d = (JSON.parse(localStorage.getItem("wishlist")) || []).filter((p) => p.handle !== a);
                if ((localStorage.setItem("wishlist", JSON.stringify(d)), Lt(d.length), t)) {
                    const p = n.closest("li");
                    (p.style.opacity = 0),
                        setTimeout(() => {
                            p.remove(), t.querySelector("li") || (t.innerHTML = St);
                        }, 600);
                }
                return;
            }
            const s = {
                    handle: a,
                    tags: "",
                    image: n.getAttribute("data-product-image"),
                    title: n.getAttribute("data-product-title"),
                    description: n.getAttribute("data-product-description"),
                },
                l = JSON.parse(localStorage.getItem("wishlist")) || [];
            l.push(s),
                localStorage.setItem("wishlist", JSON.stringify(l)),
                Lt(l.length),
                n.classList.add("wishlist-trigger--active"),
                window.location.pathname.indexOf("pages/wishlist") > -1 && window.location.reload();
        };
        document.addEventListener("click", (n) => {
            n.target.classList.contains("wishlist-trigger") && (n.preventDefault(), r(n.target));
        }),
            Array.from(document.querySelectorAll(".wishlist-trigger")).forEach((n) => {
                const o = n.getAttribute("data-product-handle");
                e.find((a) => a.handle === o) &&
                    (n.classList.add("wishlist-trigger--active"), n.classList.contains("button"));
            });
    },
    $e = () => {
        const e = new URL(window.location.href),
            t = new URLSearchParams(e.search),
            r = document.querySelector("#sale");
        t.delete("filter.p.tag"),
            r &&
                r.checked &&
                (t.append("filter.p.tag", "Sale"),
                t.append("filter.p.tag", "2022-Sale"),
                t.append("filter.p.tag", "Sale-2021"));
        const i = document.querySelector("#preorder");
        i && i.checked && t.append("filter.p.tag", "Page:POrder");
        const n = document.querySelector(".collection__facets");
        if (n) {
            let a = `${n.dataset.baseHref}/?${t.toString()}`;
            history.pushState({}, "", a);
            const s = document.querySelector("#ProductGridContainer");
            s.classList.add("loading"),
                fetch(a)
                    .then((l) => l.text())
                    .then((l) => {
                        const p = new DOMParser()
                            .parseFromString(l, "text/html")
                            .querySelector("#ProductGridContainer");
                        p && (s.classList.remove("loading"), (s.innerHTML = p.innerHTML));
                    });
        } else if (document.querySelector(".artists")) {
            const o = new CustomEvent("updateArtists", {});
            document.dispatchEvent(o);
        } else {
            const o = new CustomEvent("updateSearch", { detail: { params: `?${t.toString()}` } });
            document.dispatchEvent(o);
        }
    },
    ot = (e) => {
        const t = Array.from(e.popper.querySelectorAll('input[type="checkbox"]')).length,
            r = new URL(window.location.href),
            i = new URLSearchParams(r.search);
        if (t > 0) {
            const n = e.popper.querySelectorAll("input:checked"),
                o = e.popper.querySelector("input").name;
            i.delete(o),
                n.forEach((a) => {
                    i.append(o, a.value);
                });
        } else {
            const n = e.popper.querySelector("input[name='filter.v.price.gte']"),
                o = e.popper.querySelector("input[name='filter.v.price.lte']");
            n && n.value && i.set("filter.v.price.gte", n.value), o && o.value && i.set("filter.v.price.lte", o.value);
            const a = e.popper.querySelector(".facet__pill-option--selected");
            a ? i.set("sort_by", a.dataset.value) : i.delete("sort_by");
        }
        (r.search = i.toString()), history.pushState({}, "", r);
    },
    Ae = (e = null) => {
        document.querySelectorAll(".facet__pill").forEach((n) => {
            if (e && e.reference !== n) return;
            let o = n.querySelector(".facet__pill-label"),
                a = null,
                s = null,
                l = !1;
            if (e)
                if (((l = Array.from(e.popper.querySelectorAll('input[type="checkbox"]')).length), l))
                    (s = e.popper.querySelectorAll("input:checked").length), s > 0 && (a = `(${s})`);
                else {
                    const u = e.popper.querySelector("input[name='filter.v.price.gte']"),
                        d = e.popper.querySelector("input[name='filter.v.price.lte']");
                    u && d && u.value && d.value
                        ? (s = u.value + " - " + d.value)
                        : u && u.value
                          ? (s = u.value + "+")
                          : d && d.value && (s = "< " + d.value),
                        document.querySelectorAll("input[name='filter.v.price.gte']").forEach((m) => {
                            m.value = u ? u.value : "";
                        }),
                        document.querySelectorAll("input[name='filter.v.price.lte']").forEach((m) => {
                            m.value = d ? d.value : "";
                        });
                }
            else if (((l = n.querySelectorAll('input[type="checkbox"]').length), l > 0))
                (s = n.querySelectorAll("input:checked").length), s > 0 && (a = `(${s})`);
            else {
                s = "";
                const u = n.querySelector("input[name='filter.v.price.gte']"),
                    d = n.querySelector("input[name='filter.v.price.gte']");
                u && d && u.value && d.value
                    ? (s = "$" + u.value + " - $" + d.value)
                    : u && u.value
                      ? (s = "$" + u.value + "+")
                      : d && d.value && (s = "< $" + d.value),
                    s !== "" && (a = `(${s})`);
            }
            if (o)
                if (
                    (o.innerHTML.includes("(") && (o.innerHTML = o.innerHTML.substring(0, o.innerHTML.indexOf("("))), a)
                ) {
                    n.classList.add("facet__pill--active");
                    const u = o.innerText.trim();
                    (o.innerText = `${u} ${a}`), console.log("Adding active class", o, `${u} ${a}`);
                } else n.classList.remove("facet__pill--active");
        });
        const r = document.querySelector('button[data-template="sort-options"] .facet__pill-label');
        if (r) {
            let n = document.querySelector("#sort-options a.facet__pill-option--selected");
            e && (n = e.popper.querySelector(".facet__pill-option--selected")),
                n ? (r.innerHTML = `Sort (${n.innerText.trim()})`) : (r.innerHTML = "Sort");
        }
        const i = new URL(window.location.href);
        if (i.search.includes("POrder")) {
            const n = document.querySelector("#preorder");
            n && (n.checked = !0);
        }
        if (i.search.includes("p.tag=Sale")) {
            const n = document.querySelector("#sale");
            n && (n.checked = !0);
        }
    },
    yn = () => {
        const e = document.querySelector(".collection-hero--with-image.collection-hero--basic .collection-hero__image");
        if (e) {
            const a = () => {
                const s = window.scrollY;
                (e.style.transform = `translateY(${s * 0.3}px)`), (e.style.opacity = 1 - s * 0.001);
            };
            window.addEventListener("scroll", a);
        }
        Ae();
        const t = document.querySelectorAll(".collection-hero__product"),
            r = (a) => {
                a.classList.add("active"), typeof window.lenis < "u" ? window.lenis.scrollTo(0) : window.scrollTo(0, 0);
                const s = a.dataset.bannerIndex;
                document.querySelectorAll(".collection-hero__images").forEach((u) => {
                    u.dataset.bannerIndex == s
                        ? u.classList.remove("collection-hero__images--hidden")
                        : u.classList.add("collection-hero__images--hidden");
                });
            },
            i = document.querySelector(".collection-hero__nav-button--next");
        let n = !1;
        i &&
            i.addEventListener("click", () => {
                if (n) return;
                n = !0;
                const a = document.querySelector(".collection-hero__product.active");
                let s = null;
                a.classList.remove("active"),
                    a.nextElementSibling && a.nextElementSibling.classList.contains("collection-hero__product")
                        ? (s = a.nextElementSibling)
                        : (s = t[0]),
                    setTimeout(() => {
                        r(s),
                            setTimeout(() => {
                                n = !1;
                            }, 500);
                    }, 500);
            });
        const o = document.querySelector(".collection-hero__nav-button--prev");
        if (o) {
            o.addEventListener("click", () => {
                if (n) return;
                n = !0;
                const l = document.querySelector(".collection-hero__product.active");
                let u = null;
                l.classList.remove("active"),
                    l.previousElementSibling && l.previousElementSibling.classList.contains("collection-hero__product")
                        ? (u = l.previousElementSibling)
                        : (u = t[t.length - 1]),
                    setTimeout(() => {
                        u && r(u),
                            setTimeout(() => {
                                n = !1;
                            }, 500);
                    }, 500);
            }),
                document.querySelectorAll(".collection-hero__dots a").forEach((l) => {
                    l.addEventListener("click", (u) => {
                        u.preventDefault();
                        const d = document.querySelector(
                            ".collection-hero__images:not(.collection-hero__images--hidden)"
                        );
                        u.target.classList.contains("show-secondary")
                            ? (d.scrollLeft = d.scrollWidth)
                            : (d.scrollLeft = 0),
                            u.target
                                .closest(".collection-hero__dots")
                                .querySelectorAll("a")
                                .forEach((y) => {
                                    y.classList.remove("active");
                                }),
                            u.target.classList.add("active");
                    });
                });
            const s = document.querySelectorAll(".collection-hero__images");
            s &&
                s.forEach((l) => {
                    const u = (p) => {
                            const y = p.target.scrollLeft,
                                m = l.nextElementSibling,
                                b = m.querySelector(".show-secondary"),
                                S = m.querySelector("a:not(.show-secondary)");
                            y > 100
                                ? (S.classList.remove("active"), b.classList.add("active"))
                                : (S.classList.add("active"), b.classList.remove("active"));
                        },
                        d = debounce(u, 50);
                    l.addEventListener("scroll", d);
                });
        }
    },
    wn = (e) => {
        const { popper: t } = e;
        document.querySelectorAll(".facets__toggle").forEach((s) => {
            s.dataset.hasBinded ||
                (s.addEventListener("change", (l) => {
                    $e();
                }),
                (s.dataset.hasBinded = !0));
        });
        const i = t.querySelectorAll("#sort-options a");
        i &&
            i.forEach((s) => {
                s.addEventListener("click", (l) => {
                    l.preventDefault(), Ae(e), ot(e), $e();
                });
            });
        const n = t.querySelectorAll(".facet__footer-close");
        n &&
            n.forEach((s) => {
                s.addEventListener("click", () => {
                    Ae(e), ot(e), $e(), e.hide();
                });
            });
        const o = t.querySelectorAll(".facet__pill-option");
        o &&
            o.forEach((s) => {
                s.addEventListener("click", () => {
                    s
                        .closest(".tippy-content")
                        .querySelectorAll(".facet__pill-option")
                        .forEach((d) => {
                            d !== s && d.classList.remove("facet__pill-option--selected");
                        }),
                        s.classList.toggle("facet__pill-option--selected"),
                        ot(e),
                        Ae(e),
                        $e(),
                        e.hide();
                });
            });
        const a = t.querySelector(".facet__clear");
        a &&
            a.addEventListener("click", (s) => {
                s.preventDefault();
                const l = a.closest(".tippy-content");
                l.querySelectorAll("input:checked").forEach((p) => {
                    p.checked = !1;
                }),
                    l.querySelectorAll('input[type="number"]').forEach((p) => {
                        p.value = "";
                    }),
                    Ae(e),
                    ot(e),
                    $e(),
                    e.hide();
            });
    },
    bn = (e) => {
        const t = new URL(window.location.href),
            r = new URLSearchParams(t.search);
        let i = !1;
        e.popper.querySelectorAll("input[name=genre]").length > 0
            ? (i = r.getAll("genre"))
            : e.popper.querySelectorAll("input[name=label]").length > 0 && (i = r.getAll("label")),
            i &&
                (i.forEach((n) => {
                    const o = e.popper.querySelector(`input[value="${n}"]`);
                    o && (o.checked = !0);
                }),
                Ae(e));
    },
    Sn = () => {
        const e = document.querySelector(".slider__items"),
            t = document.querySelector(".slider__wrapper");
        if (!e || !t) return;
        const r = e.querySelector(".slider__slide");
        let i = !1,
            n = 0,
            o = 0,
            a = 16,
            s = 0,
            l = 0,
            u = 0,
            d = 0,
            p = !1;
        const y = () => {
            (u = Math.abs(e.offsetWidth - t.offsetWidth)), (l = r.offsetWidth), (d = Math.ceil(u / l));
        };
        window.addEventListener("resize", () => {
            y();
        }),
            y();
        let m = 0;
        e.addEventListener("wheel", (h) => {
            if ((h.preventDefault(), !h.deltaX || (h.deltaX < 3 && h.deltaX > -3))) return;
            window.lenis.stop();
            let E = h.deltaX * 0.4,
                _ = m + E * -1;
            return (
                _ > 0 && (_ = 0),
                _ < u * -1 && (_ = u * -1),
                (m = _),
                (e.style.transform = `translate3d(${_}px, 0, 0)`),
                window.lenis.start(),
                !1
            );
        });
        const b = (h) => {
                if (p) return;
                let E = 0,
                    _ = 0;
                h instanceof TouchEvent
                    ? ((E = h.touches[0].pageX), (_ = h.touches[0].pageY))
                    : ((E = h.pageX), (_ = h.pageY)),
                    e.classList.remove("active");
                let c = Math.abs(n - E);
                if (Math.abs(o - _) > c) return !1;
                if (c < 12) return h.preventDefault(), !1;
                if ((h.preventDefault(), (p = !0), n > E)) {
                    if (s < d) {
                        s += 1;
                        let v = s * l + (s - 1) * a;
                        v > u && (v = u), (e.style.transform = `translateX(-${v}px)`), (n = E);
                    }
                } else if (s > 0) {
                    s -= 1;
                    let v = 0;
                    s > 0 && (v = s * l + (s - 1) * a), (n = E), (e.style.transform = `translateX(-${v}px)`);
                }
                return (
                    setTimeout(() => {
                        p = !1;
                    }, 300),
                    !1
                );
            },
            S = (h) => {
                (i = !0),
                    e.classList.add("active"),
                    h instanceof TouchEvent
                        ? ((n = h.touches[0].pageX - e.offsetLeft), (o = h.touches[0].pageY - e.offsetTop))
                        : ((n = h.pageX - e.offsetLeft), (o = h.pageY - e.offsetTop));
            },
            w = (h) => {
                (i = !1), e.classList.remove("active");
            };
        e.addEventListener("mousedown", (h) => {
            S(h);
        }),
            e.addEventListener("mouseup", (h) => {
                b(h);
            }),
            e.addEventListener("mouseleave", (h) => {
                w();
            }),
            e.addEventListener(
                "touchstart",
                (h) => {
                    h.preventDefault(),
                        S(h),
                        setTimeout(() => {
                            i == !1 && !p && h.target.tagName.toLowerCase();
                        }, 200);
                },
                { passive: !0 }
            ),
            e.addEventListener("touchmove", (h) => b(h), { passive: !0 }),
            e.addEventListener("touchend", (h) => {
                w();
            }),
            e.addEventListener("touchcancel", (h) => {
                w();
            }),
            e.addEventListener("mousemove", (h) => {
                i && h.preventDefault();
            });
    },
    Ln = () => {
        const e = document.querySelector(".featured-search__form input"),
            t = document.querySelector(".featured-search__form"),
            r = document.querySelector(".featured-search__list");
        if (!e || !t || e.closest(".artists") || e.closest(".template-search")) return;
        const i = document.querySelector(".featured-search__form button");
        i &&
            i.addEventListener("click", () => {
                (e.value = ""), t.classList.remove("featured-search__form--active"), e.focus();
            });
        const n = () => {
            const a = e.value;
            fetch(`/search/suggest?q=${a}&section_id=predictive-search`)
                .then((s) => s.text())
                .then((s) => {
                    if (a !== e.value) return;
                    r.innerHTML = "";
                    const d = new DOMParser().parseFromString(s, "text/html").querySelectorAll("[data-artist]");
                    if (d.length > 0)
                        d.forEach((p, y) => {
                            r.appendChild(p),
                                p.addEventListener("keydown", (m) => {
                                    if (m.keyCode === 27) {
                                        m.preventDefault(),
                                            (e.value = ""),
                                            t.classList.remove("featured-search__form--active");
                                        return;
                                    }
                                    m.keyCode === 38 && (m.preventDefault(), y == 0 ? e.focus() : d[y - 1].focus()),
                                        m.keyCode === 40 && (m.preventDefault(), y < d.length - 1 && d[y + 1].focus());
                                });
                        });
                    else {
                        const p = document.createElement("div");
                        p.classList.add("featured-search__empty"), (p.innerText = "No results found"), r.appendChild(p);
                    }
                    t.classList.remove("featured-search__form--loading");
                })
                .catch((s) => {
                    console.error(s), t.classList.remove("featured-search__form--loading");
                });
        };
        e.addEventListener("focus", () => {
            if (!e.value) {
                t.classList.remove("featured-search__form--active"), (t.querySelector("input").value = "");
                return;
            }
            t.classList.add("featured-search__form--active");
        }),
            e.addEventListener("keydown", (a) => {
                (a.keyCode === 40 || a.keyCode === 9) &&
                    (a.preventDefault(), r.firstElementChild && r.firstElementChild.focus());
            }),
            e.addEventListener("input", (a) => {
                if (!e.value) {
                    t.classList.remove("featured-search__form--active"), (t.querySelector("input").value = "");
                    return;
                }
                t.classList.add("featured-search__form--active"), t.classList.add("featured-search__form--loading");
            }),
            e.addEventListener("input", debounce(n, 300));
        function o(a) {
            a.target.closest(".featured-search");
        }
        document.addEventListener("focus", o, !0);
    },
    En = () => {
        let e = !1,
            t = !1;
        window.innerWidth < 1025 && (t = !0);
        const r = document.querySelectorAll(".banner__featured-image");
        if (!r.length) return;
        const i = (a) => {
                let s = document.querySelector(".banner__featured-slide--active");
                s &&
                    (s.classList.remove("banner__featured-slide--active"),
                    s.classList.add("banner__featured-slide--preview"),
                    s.setAttribute("aria-hidden", "true"),
                    s.setAttribute("tabindex", "-1")),
                    a.classList.add("banner__featured-slide--active"),
                    a.classList.remove("banner__featured-slide--preview"),
                    a.removeAttribute("aria-hidden"),
                    a.setAttribute("tabindex", "0");
            },
            n = (a, s) => {
                if ((a.preventDefault(), e)) return;
                e = !0;
                let l = s.closest(".banner__featured-slide");
                if (l.classList.contains("banner__featured-slide--active")) {
                    e = !1;
                    return;
                } else i(l);
                setTimeout(() => {
                    e = !1;
                }, 500);
            },
            o = setInterval(() => {
                if ((window.innerWidth < 1025 && (t = !0), t)) {
                    t = !1;
                    return;
                }
                if (e) return;
                let s = document.querySelector(".banner__featured-slide--active").nextElementSibling;
                s || (s = document.querySelector(".banner__featured-slide")), i(s);
            }, 8e3);
        r.forEach((a) => {
            a.addEventListener("click", (s) => {
                (t = !0), clearInterval(o), n(s, a);
            });
        });
    };
class _n extends HTMLElement {
    connectedCallback() {
        this.classList.add("loading-animation"),
            (this.innerHTML = `
            <div></div><div></div><div></div><div></div><div></div>
        `);
    }
}
customElements.define("loading-component", _n);
const Et = (e) => {
        if (!e) return "";
        let t = e.replace(/[^a-zA-Z0-9]/g, "");
        return (t = t.replace(/\s/g, "")), t;
    },
    An = (e, t, r, i) => {
        let n = Et(t);
        const o = Et(e.getAttribute("data-name").toLowerCase()),
            a = Et(e.getAttribute("data-search-context").toLowerCase());
        let s = !0;
        return (
            r.length > 0 &&
                ((s = !1),
                e.getAttribute("data-genres") &&
                    e
                        .getAttribute("data-genres")
                        .split(",")
                        .forEach((u) => {
                            r.indexOf(u) > -1 && (s = !0);
                        })),
            s &&
                i.length > 0 &&
                e.getAttribute("data-labels") &&
                e
                    .getAttribute("data-labels")
                    .split(",")
                    .forEach((u) => {
                        i.indexOf(u) > -1 && (s = !0);
                    }),
            n && s && ((s = !1), (o.indexOf(n) > -1 || a.indexOf(n) > -1) && (s = !0)),
            s
        );
    },
    Tn = () => {
        const e = document.querySelector(".artists"),
            t = document.querySelector(".artists__grid"),
            r = document.querySelector(".header-group"),
            i = document.querySelector(".artists__header");
        if (!e || !t) return;
        let n = Array.from(e.querySelectorAll(".artists__title")),
            o = Array.from(e.querySelectorAll(".artists__grid-item"));
        const a = Array.from(e.querySelectorAll(".artists__header-abc button")),
            s = (b) => {
                const S = b.target.getAttribute("data-letter"),
                    w = e.querySelector(`.artists__title[data-letter="${S}"]`);
                if (w) {
                    const h = 84,
                        E = w.getBoundingClientRect().top + window.scrollY - h;
                    window.scrollTo({ top: E, behavior: "smooth" });
                }
            };
        a.forEach((b) => {
            b.addEventListener("click", s);
        });
        const l = () => {
                const b = Array.from(e.querySelectorAll(".artists__grid-item"));
                b.sort((w, h) => {
                    const E = w.getAttribute("data-letter"),
                        _ = h.getAttribute("data-letter");
                    return E < _ ? -1 : E > _ ? 1 : 0;
                }),
                    b.forEach((w) => {
                        w.remove();
                    });
                let S = "";
                b.forEach((w) => {
                    const h = w.getAttribute("data-letter");
                    if (h !== S) {
                        const E = document.createElement("div");
                        E.dataset.letter = h;
                        const _ = document.createElement("h2");
                        E.classList.add("artists__title"),
                            (_.innerHTML = h),
                            E.appendChild(_),
                            t.appendChild(E),
                            (S = h);
                    }
                    t.appendChild(w);
                }),
                    (n = Array.from(e.querySelectorAll(".artists__title"))),
                    (o = Array.from(e.querySelectorAll(".artists__grid-item"))),
                    setTimeout(() => {
                        p(null), t.classList.remove("loading");
                        const w = Array.from(e.querySelectorAll(".artists__title")),
                            h = () => {
                                let c = null;
                                if (
                                    (w.forEach((g) => {
                                        if (!c) {
                                            c = g;
                                            return;
                                        }
                                        window.scrollY > g.dataset.scrollSpyPoint && (c = g);
                                    }),
                                    c)
                                ) {
                                    const g = c.dataset.letter,
                                        v = e.querySelector(`.artists__header-abc button[data-letter="${g}"]`);
                                    if (v) {
                                        const T = e.querySelector(".artists__header-abc button.active");
                                        T && T.classList.remove("active"), v.classList.add("active");
                                    }
                                }
                            },
                            E = () => {
                                const c = r.offsetHeight + i.offsetHeight;
                                w.forEach((g) => {
                                    const v = g.getBoundingClientRect().top + window.scrollY - c;
                                    g.dataset.scrollSpyPoint = v;
                                });
                            };
                        E(), window.addEventListener("resize", E);
                        let _ = null;
                        window.addEventListener("scroll", () => {
                            _ && window.cancelAnimationFrame(_), (_ = window.requestAnimationFrame(h));
                        });
                    }, 100);
            },
            u = async (b) => {
                const S = `/collections?page=${b}`;
                console.log(S);
                const h = await (await fetch(S)).text(),
                    _ = new DOMParser().parseFromString(h, "text/html");
                Array.from(_.querySelectorAll(".artists__grid-item")).forEach((g) => {
                    t.appendChild(g);
                });
            };
        (async () => {
            await u(2), await u(3), await u(4), await u(5), await u(6), await u(7), await u(8), await u(9), l();
        })();
        const p = (b) => {
                const S = new URL(window.location.href),
                    w = new URLSearchParams(S.search),
                    h = w.getAll("genre"),
                    E = w.getAll("label");
                let _ = [],
                    c = !0;
                o.forEach((g) => {
                    if (An(g, b, h, E)) {
                        g.classList.remove("hidden"), g.setAttribute("tabindex", "0");
                        const T = g.getAttribute("data-letter");
                        _.push(T), (c = !1);
                    } else g.classList.add("hidden"), g.setAttribute("tabindex", "-1");
                }),
                    n.forEach((g) => {
                        const v = g.dataset.letter;
                        _.indexOf(v) < 0 ? g.classList.add("hidden") : g.classList.remove("hidden");
                    }),
                    a.forEach((g) => {
                        const v = g.getAttribute("data-letter");
                        _.indexOf(v) < 0 ? g.setAttribute("disabled", "disabled") : g.removeAttribute("disabled");
                    }),
                    c ? t.classList.add("artist__grid--empty") : t.classList.remove("artist__grid--empty");
            },
            y = document.querySelector(".featured-search__input");
        if (y) {
            const b = (h) => {
                    const E = h.target.value.toLowerCase(),
                        _ = r.offsetHeight + i.offsetHeight + 20,
                        c = t.getBoundingClientRect().top + window.scrollY - _;
                    window.scrollTo({ top: c, behavior: "instant" }), p(E);
                },
                S = window.innerWidth > 1e3 ? 200 : 700,
                w = debounce(b, S);
            y.addEventListener("input", w);
        }
        window.addEventListener("popstate", () => {
            p(y ? y.value : null);
        }),
            window.addEventListener("pushstate", () => {
                p(y ? y.value : null);
            });
        const m = document.querySelector(".featured-search__form button");
        m && m.addEventListener("click", (b) => (b.preventDefault(), (y.value = ""), p(null), !1)),
            document.addEventListener("updateArtists", () => {
                p(y ? y.value : null);
            });
    },
    xn = () => {
        const e = document.querySelectorAll("[data-add-to-cart]");
        e &&
            e.forEach((t) => {
                t.addEventListener("click", (r) => {
                    typeof _satellite < "u" && _satellite.track("cart add");
                });
            });
    },
    On = () => {
        if (!document.querySelector(".template-search")) return;
        const e = new AbortController();
        document.addEventListener("click", (r) => {
            if (r.target.matches('button[type="reset"]')) {
                r.preventDefault();
                const i = r.target.closest("form");
                if (i) {
                    const n = i.querySelector('input[type="text"]');
                    n && ((n.value = ""), n.dispatchEvent(new Event("input", { bubbles: !0 })), n.focus());
                }
            }
        });
        const t = (r) => {
            const i = document.querySelector(".search-results__artists");
            if (!i) {
                r();
                return;
            }
            const n = new URLSearchParams(window.location.search);
            if (n.has("q")) {
                const o = n.get("q");
                fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(o)}&section_id=predictive-search`, {
                    signal: e.signal,
                })
                    .then((a) => {
                        if (!a.ok) {
                            var s = new Error(a.status);
                            throw s;
                        }
                        return a.text();
                    })
                    .then((a) => {
                        const u = new DOMParser().parseFromString(a, "text/html").querySelectorAll("[data-artist]");
                        if (u.length > 0) {
                            (i.innerHTML = ""),
                                u.forEach((p) => {
                                    i.appendChild(p);
                                }),
                                i.classList.remove("hidden");
                            const d = document.createElement("h2");
                            d.classList.add("heading-lg"), (d.innerHTML = "Artists"), i.parentNode.insertBefore(d, i);
                        }
                        r();
                    })
                    .catch((a) => {
                        console.error(a), r();
                    });
            } else r();
        };
        document.addEventListener("updateSearch", (r) => {
            const { params: i } = r.detail;
            document.querySelector(".search-results").classList.add("search-results--loading");
            let n = window.location.href;
            (n = n.split("?")[0]),
                (n += `${i}&q=${encodeURIComponent(document.querySelector(".featured-search__input").value)}`),
                history.pushState({}, "", n),
                fetch(n, { method: "GET" })
                    .then((o) => o.text())
                    .then((o) => {
                        const s = new DOMParser().parseFromString(o, "text/html");
                        (document.querySelector(".search-results").innerHTML =
                            s.querySelector(".search-results").innerHTML),
                            t(() => {
                                document.querySelector(".search-results").classList.remove("search-results--loading");
                            });
                    })
                    .catch((o) => {
                        console.error(o);
                    });
        }),
            t(() => {});
    },
    qn = () => {
        const e = document.querySelector("#newsletter-popout");
        if (!e) {
            console.warn("No popout element found");
            return;
        }
        const t = localStorage.getItem("newsletter-popout-hidden");
        if (!new URLSearchParams(window.location.search).get("popout") && t) {
            console.warn("Popout element found but hidden");
            return;
        }
        let n = !1;
        const o = () => {
            const u =
                window.scrollY > window.innerHeight && window.scrollY < document.body.clientHeight - window.innerHeight;
            console.warn({ showPopOut: u }),
                u && !n
                    ? (e.classList.remove("off-screen"), (n = !0))
                    : !u && n && (e.classList.add("off-screen"), (n = !1));
        };
        o();
        const a = e.querySelector(".newsletter-popout__close");
        a &&
            a.addEventListener("click", () => {
                e.classList.add("off-screen"), localStorage.setItem("newsletter-popout-hidden", new Date().getTime());
            });
        const s = e.querySelector("form");
        s &&
            s.addEventListener("submit", (u) => {
                u.preventDefault();
                const d = document.querySelector("#footer-modal");
                if (d) {
                    const p = d.querySelector('input[name="email"]');
                    p && (p.value = s.querySelector(".input-text").value), MicroModal.show("footer-modal");
                }
                return !1;
            });
        let l;
        return {
            scroll: () => {
                clearTimeout(l), (l = setTimeout(o, 100));
            },
        };
    },
    Cn = () => {
        document.querySelectorAll(".rte table:not(.wrapped)").forEach((r) => {
            const i = document.createElement("div");
            i.classList.add("responsive-table"), r.classList.add("wrapped"), i.appendChild(r.cloneNode(!0));
            const n = document.createElement("div");
            n.classList.add("responsive-table-wrapper"), n.appendChild(i), r.parentNode.insertBefore(n, r), r.remove();
        }),
            document.querySelectorAll("p").forEach((r) => {
                r.innerHTML === "&nbsp;" && r.remove();
            });
    };
let nr = qn();
try {
    pn(), gn(), yn(), Sn(), Ln(), En(), Tn(), On(), Cn();
} catch (e) {
    console.error(e);
}
Ot.init({
    disableScroll: !0,
    onShow: (e) => {
        console.error("modal", e), lenis.stop();
    },
    onClose: (e) => {
        lenis.start();
    },
});
{
    let t = function (r) {
        e.raf(r), requestAnimationFrame(t);
    };
    var kn = t;
    const e = new Pr();
    e.on("scroll", (r) => {
        nr && nr.scroll();
    }),
        (window.lenis = e),
        requestAnimationFrame(t);
}
document.documentElement.className = document.documentElement.className.replace("no-js", "js");
try {
    Ce("[data-tippy-content]", {
        dynamicTitle: !0,
        onShow(e) {
            setTimeout(() => {
                e.hide();
            }, 2e3);
        },
    }),
        Ce(".tippy", {
            content(e) {
                const t = e.getAttribute("data-template"),
                    r = document.getElementById(t);
                return r ? r.innerHTML : "";
            },
            trigger: "click",
            interactive: !0,
            placement: "bottom-start",
            appendTo: document.body,
            allowHTML: !0,
            onShow(e) {
                const t = e.popper.querySelector(".tippy-close");
                t &&
                    t.addEventListener("click", () => {
                        e.hide();
                    });
            },
            onCreate(e) {
                wn(e), bn(e);
            },
            onHide(e) {
                const t = e.popper.querySelector(".tippy-close");
                t &&
                    t.removeEventListener("click", () => {
                        e.hide();
                    });
            },
        });
} catch (e) {
    console.error(e);
}
try {
    let t = function () {
        e.forEach((r) => {
            let i = r.parentNode;
            i != this.parentNode && i.removeAttribute("open");
        });
    };
    var Dn = t;
    const e = Array.from(document.querySelectorAll(".product__accordion summary"));
    e.forEach((r) => {
        r.addEventListener("click", t);
    });
} catch (e) {
    console.error(e);
}
try {
    document.querySelectorAll(".footer .input-text").forEach((t) => {
        t.addEventListener("focus", () => {
            t.closest("form").classList.remove("show-error");
        }),
            t.addEventListener("blur", () => {
                t.closest("form").classList.add("show-error");
            }),
            t.addEventListener("input", () => {
                t.value && t.closest("form").classList.remove("show-error");
            });
    });
} catch (e) {
    console.error(e);
}
xn();
